<template>
  <div style="margin-top: -30px">
    <div>
      <!-- <div style="display:flex">
                <h4>New Payment Schedule</h4>
            </div> -->
      <div style="padding-left: 10px">
        <div class="row">
          <div class="col-sm-12" style="text-align: right">
            <label style="color: #c1c2c3">PS No:</label>
            <label style="min-width: 100px">{{
              paymentScheduleForm.psNo
            }}</label>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-5" style="padding: 10px">
            <div style="background-color: #fafbfc; padding: 10px; height: 100%">
              <div style="display: flex">
                <h4>Information</h4>
                <h3
                  v-if="isSpecial"
                  class="text-secondary"
                  style="flex-grow: 1; text-align: right"
                >
                  SPECIAL SCHEDULE
                </h3>
              </div>
              <base-input
                label="Description"
                class="range-picker"
                :disabled="type != 'edit' && type != 'new'"
                v-model="paymentScheduleForm.description"
              >
              </base-input>
              <div
                style="position: absolute; right: 20px; text-align: right"
                v-if="numberOfSchedule != 0"
              >
                No. of Days: {{ numberOfSchedule }}
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <base-input
                    label="Schedule Period"
                    :class="{
                      'range-picker': true,
                    }"
                  >
                    <el-date-picker
                      :clearable="false"
                      type="daterange"
                      placeholder="Schedule Period"
                      v-model="paymentScheduleForm.campaignPeriod"
                      class="form-control"
                      :disabled-date="(val) => disabledDate(val)"
                      :disabled="
                        (type != 'edit' && type != 'new') ||
                        paymentScheduleForm.paymentType == 'burst' ||
                        info_disable
                      "
                      value-format="YYYY-MM-DD"
                      format="DD/MM/YYYY"
                      @change="ChangeSchedulePeriod"
                    >
                    </el-date-picker>
                  </base-input>
                  <div
                    :class="{
                      'regroup-outstanding': true,
                    }"
                    v-if="
                      type !== 'view' &&
                      paymentScheduleForm.psNo &&
                      (new Date(disableCampaignDate[0]).getTime() !==
                        new Date(
                          paymentScheduleForm.campaignPeriod[0]
                        ).getTime() ||
                        new Date(disableCampaignDate[1]).getTime() !==
                          new Date(
                            paymentScheduleForm.campaignPeriod[1]
                          ).getTime())
                    "
                  >
                    Contract Campaign Period: &nbsp;
                    <label class="input-label" for="">{{
                      FormatterDate('', '', disableCampaignDate?.[0])
                    }}</label>
                    -
                    <label class="input-label" for="">{{
                      FormatterDate('', '', disableCampaignDate?.[1])
                    }}</label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6">
                  <base-input
                    label="Schedule Media Amount"
                    class="range-picker"
                  >
                    <money-input
                      class="payment-money-input"
                      :disabled="
                        (type != 'edit' && type != 'new') ||
                        activeName === 'production' ||
                        paymentScheduleForm.paymentType == 'burst' ||
                        info_disable
                      "
                      v-model="paymentScheduleForm.mediaTotal"
                      style="background-color: #f5f5f5; color: #685b51"
                    />
                  </base-input>
                  <div
                    class="regroup-outstanding"
                    v-if="
                      OutstandingMediaAmount !== 0 &&
                      paymentScheduleForm.psNo &&
                      type !== 'view'
                    "
                  >
                    Outstanding:
                    {{ FormatterMoney('', '', OutstandingMediaAmount) }}
                  </div>
                </div>
                <div class="col-sm-6">
                  <base-input
                    label="Schedule Production Amount"
                    class="range-picker"
                  >
                    <money-input
                      class="payment-money-input"
                      :disabled="
                        (type != 'edit' && type != 'new') ||
                        activeName === 'media' ||
                        paymentScheduleForm.paymentType == 'burst' ||
                        info_disable
                      "
                      :model="paymentScheduleForm.productionTotal"
                      v-model="paymentScheduleForm.productionTotal"
                      style="background-color: #f5f5f5; color: #685b51"
                    />
                  </base-input>
                  <div
                    class="regroup-outstanding"
                    v-if="
                      OutstandingProductionAmount !== 0 &&
                      paymentScheduleForm.psNo &&
                      type !== 'view'
                    "
                  >
                    Outstanding:
                    {{ FormatterMoney('', '', OutstandingProductionAmount) }}
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6">
                  <base-input
                    label="Total Schedule Amount"
                    class="range-picker"
                    disabled
                  >
                    <money-input
                      class="payment-money-input"
                      :model="
                        FormatterMoneyInput(paymentScheduleForm.grandTotal)
                      "
                      disabled
                    />
                  </base-input>
                  <div
                    class="regroup-outstanding"
                    v-if="
                      (OutstandingProductionAmount !== 0 ||
                        OutstandingMediaAmount !== 0) &&
                      paymentScheduleForm.psNo &&
                      type !== 'view'
                    "
                  >
                    Outstanding:
                    {{
                      FormatterMoney(
                        '',
                        '',
                        OutstandingMediaAmount + OutstandingProductionAmount
                      )
                    }}
                  </div>
                </div>
                <div class="col-sm-6">
                  <div style="margin-bottom: 0.2rem">&nbsp;</div>
                  <div class="text-right">
                    <base-button
                      type="primary"
                      :disabled="reviseUpdate_disable"
                      @click="ReviseUpdate"
                      >Update Revise</base-button
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-4" style="padding: 10px">
            <div style="background-color: #fafbfc; padding: 10px; height: 100%">
              <div>
                <h4>Schedule Setting</h4>
              </div>
              <base-input label="Payment Type" class="range-picker">
                <el-select
                  class="select-primary"
                  size="large"
                  placeholder="Payment Type"
                  v-model="paymentScheduleForm.paymentType"
                  filterable
                  style="width: 100%"
                  :disabled="type == 'view' || scheduleSetting_disable"
                  @change="getPaymentScheduleTermsGG"
                >
                  <el-option
                    label="Full Payment"
                    value="fullpayment"
                  ></el-option>
                  <el-option label="Burst" value="burst"></el-option>
                  <el-option
                    label="Installment"
                    value="installment"
                  ></el-option>
                  <!-- <el-option
                    v-for="item in paymentType"
                    :key="item"
                    :label="item.Name"
                    :value="item.Code"
                  ></el-option> -->
                </el-select>
              </base-input>
              <div
                class="row"
                v-if="paymentScheduleForm.paymentType == 'installment'"
              >
                <div class="col-sm-6" v-if="false">
                  <label style="margin-bottom: 0px">Mode</label>
                  <el-radio-group
                    v-model="installmentMode"
                    class="ml-4"
                    :disabled="type == 'view'"
                  >
                    <el-radio label="month" size="large">Month</el-radio>
                    <el-radio label="day" size="large">Day</el-radio>
                  </el-radio-group>
                </div>
                <div class="col-sm-12">
                  <div class="row">
                    <div class="col-sm-6">
                      <base-input
                        :label="installmentTitle"
                        class="range-picker"
                      >
                        <el-input
                          style="background-color: #f5f5f5; color: #685b51"
                          v-model="installmentNumberOf"
                          @change="
                            installmentNumberOf = FixNumber(installmentNumberOf)
                          "
                          :disabled="type == 'view' || scheduleSetting_disable"
                        />
                      </base-input>
                    </div>
                    <div class="col-sm-6">
                      <base-input label="Early Deposit" class="range-picker">
                        <el-input
                          style="background-color: #f5f5f5; color: #685b51"
                          v-model="earlyDeposit"
                          @change="earlyDeposit = FixNumber(earlyDeposit)"
                          :disabled="type == 'view' || scheduleSetting_disable"
                        />
                      </base-input>
                    </div>
                    <div class="col-sm-12">
                      <base-checkbox
                        style="
                          width: 100%;
                          padding-left: 0px;
                          padding-bottom: 10px;
                        "
                        v-model="isFixDate"
                        :disabled="fixDate_disable"
                        @click="
                          (event) => checkForPaymentDue(event.target.checked)
                        "
                        >Fix Payment Due Date of Month</base-checkbox
                      >
                      <div class="row">
                        <div class="col-sm-6">
                          <base-input label="" class="range-picker">
                            <el-input
                              style="background-color: #f5f5f5; color: #685b51"
                              v-model="fixDate"
                              :disabled="type == 'view' || !isFixDate"
                              @focus="fixDate = ''"
                              @blur="fixDate = FixNumberv2(fixDate)"
                              max="31"
                            />
                          </base-input>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12" v-if="false">
                  <label style="margin-bottom: 0px">Split Preference</label>
                  <el-radio-group
                    v-model="splitPref"
                    class="ml-4"
                    :disabled="type == 'view'"
                  >
                    <el-radio label="ssd" size="large"
                      >Same Date of SSD</el-radio
                    >
                    <el-radio
                      label="fix"
                      size="large"
                      :disabled="installmentMode == 'day'"
                      >Fix Payment Due Date of Month<el-input
                        size="small"
                        v-model="fixDate"
                        :disabled="
                          installmentMode == 'day' || splitPref == 'ssd'
                        "
                        style="width: 30%; margin-left: 10px"
                      ></el-input
                    ></el-radio>
                  </el-radio-group>
                  <!-- <div>
                                        <base-radio style="width:100%">Same Date of SSD</base-radio>
                                        <base-radio style="width:100%">Fix Date of Month</base-radio>
                                    </div> -->
                </div>
              </div>
              <!-- <base-input label="Contract Campaign Period">
                                <el-input value="01/08/2022 - 31/08/2022"
                                    style="background-color: #f5f5f5;color: #685b51;" />
                            </base-input> -->
            </div>
          </div>
          <div class="col-sm-3" style="padding: 10px">
            <div style="background-color: #fafbfc; padding: 10px; height: 100%">
              <div>
                <h4>
                  Terms
                  <el-popover
                    placement="bottom"
                    title="Terms"
                    :width="340"
                    trigger="hover"
                    content="this is content, this is content, this is content"
                  >
                    <template #reference>
                      <el-icon style="position: relative; top: 3px">
                        <Warning />
                      </el-icon>
                      <!-- <el-button>Hover to activate</el-button> -->
                    </template>
                    <template #default>
                      <div class="term-description">
                        <div class="row">
                          <div class="col-sm-4">
                            <div class="title">Short Code</div>
                            <div>COD:</div>
                            <div>SSD:</div>
                            <div>SED:</div>
                          </div>
                          <div class="col-sm-8">
                            <div class="title">Description</div>
                            <div>Cash On Delivery</div>
                            <div>Schedule Period - Start Date</div>
                            <div>Schedule Period - End Date</div>
                          </div>
                        </div>
                      </div>
                    </template>
                  </el-popover>
                </h4>
              </div>
              <base-input label="Payment Term" class="range-picker">
                <el-select
                  class="select-primary"
                  size="large"
                  placeholder=" "
                  v-model="paymentScheduleForm.paymentTerm"
                  filterable
                  style="width: 100%"
                  :disabled="
                    // !bEnablePaymentTerm || type === 'view' || specialTerms
                    //type === 'view' || specialTerms
                    paymentTerm_disable
                  "
                >
                  <el-option
                    v-for="item in paymentTerm"
                    :key="item"
                    :label="item.Name"
                    :value="item.Code"
                  ></el-option>
                </el-select>
              </base-input>
              <base-input label="Invoice Term" class="range-picker">
                <el-select
                  class="select-primary"
                  size="large"
                  placeholder="Invoice Term"
                  v-model="paymentScheduleForm.invoiceTerm"
                  filterable
                  style="width: 100%"
                  :disabled="
                    // !bEnableInvoiceTerm || type === 'view'
                    type === 'view'
                  "
                >
                  <el-option
                    v-for="item in invoiceTerm"
                    :key="item"
                    :label="item.Name"
                    :value="item.Code"
                  ></el-option>
                </el-select>
              </base-input>
              <!-- <div>
                <label>Special Payment Term</label>
                <div class="form-group spe" style="display: flex">
                  <div style="margin-top: 12px; margin-right: 10px">
                    <base-checkbox
                      style="margin-top: 0"
                      class="special-payment-term"
                    ></base-checkbox>
                  </div>
                  <div style="width: 30%; margin-right: 10px">
                    <el-select
                      class="select-primary"
                      size="large"
                      placeholder=" "
                      style="width: 100%"
                    >
                      <el-option
                        v-for="item in ['SED', 'SSD']"
                        :key="item"
                        :label="item"
                        :value="item"
                      ></el-option>
                    </el-select>
                  </div>
                  <div style="width: 30%; margin-right: 10px">
                    <el-select
                      class="select-primary"
                      size="large"
                      placeholder=" "
                      style="width: 100%"
                    >
                      <el-option
                        v-for="item in ['+', '-']"
                        :key="item"
                        :label="item"
                        :value="item"
                      ></el-option>
                    </el-select>
                  </div>
                  <div style="flex-grow: 1">
                    <el-input class="black"></el-input>
                  </div>
                </div>
              </div> -->

              <base-input label="Special Payment Term" class="range-picker">
                <div class="row">
                  <div
                    class="col-sm-1"
                    style="padding-left: 10px; padding-right: 10px"
                  >
                    <base-checkbox
                      v-model="specialTerms"
                      :disabled="specialTerms_disable"
                      >&nbsp;</base-checkbox
                    >
                  </div>
                  <div
                    class="col-sm-4"
                    style="padding-left: 10px; padding-right: 10px"
                  >
                    <el-select
                      class="select-primary"
                      size="large"
                      placeholder=" "
                      v-model="specialTerm.SpecialTermType"
                      filterable
                      style="width: 100%"
                      :disabled="
                        !specialTerms ||
                        type == 'view' ||
                        useContract.getContractFunctionPermission(
                          'SpecialPaymentTerm'
                        )?.disable
                      "
                    >
                      <el-option label="SSD" value="ssd"></el-option>
                      <el-option label="SED" value="sed"></el-option>
                    </el-select>
                  </div>
                  <div
                    class="col-sm-3"
                    style="padding-left: 10px; padding-right: 10px"
                  >
                    <el-select
                      class="select-primary"
                      size="large"
                      placeholder=" "
                      v-model="specialTerm.Formula"
                      filterable
                      style="width: 100%"
                      :disabled="
                        !specialTerms ||
                        type == 'view' ||
                        useContract.getContractFunctionPermission(
                          'SpecialPaymentTerm'
                        )?.disable
                      "
                    >
                      <el-option label="+" value="+"></el-option>
                      <el-option label="-" value="-"></el-option>
                    </el-select>
                  </div>
                  <div
                    class="col-sm-4"
                    style="padding-left: 10px; padding-right: 10px"
                  >
                    <el-input-number
                      id="SpecialPayDaysId"
                      :step="1"
                      :step-strictly="true"
                      :min="1"
                      controls-position="right"
                      :formatter="
                        (value) => (parseInt(value || '0') < 0 ? 0 : value)
                      "
                      :disabled="
                        !specialTerms ||
                        type == 'view' ||
                        useContract.getContractFunctionPermission(
                          'SpecialPaymentTerm'
                        )?.disable
                      "
                      v-model="SpecialPayDays"
                      class="special-terms-days black"
                    />
                  </div>
                </div>
              </base-input>
              <!-- <base-input label="Contract Campaign Period">
                                <el-input value="01/08/2022 - 31/08/2022"
                                    style="background-color: #f5f5f5;color: #685b51;" />
                            </base-input> -->
            </div>
          </div>
          <div class="col-sm-6" style="margin-top: 10px">
            <el-button
              type="primary"
              @click="generateSchedule()"
              :disabled="regenerate_disable"
              style="width: 144px"
              >Regenerate</el-button
            >
            <el-dropdown
              :disabled="regroup_disable"
              v-if="
                (paymentScheduleForm.psNo || regroupData) &&
                paymentScheduleForm.paymentType === 'installment'
              "
              trigger="click"
              class="round-dropdown payment-dropdown"
              style="margin-left: 15px"
              @command="RegroupHandler"
            >
              <div style="display: flex; width: 144px">
                <span
                  style="
                    font-size: 14px;
                    padding-left: 35px;
                    padding-right: 35px;
                  "
                  >Regroup
                </span>
                <span style="padding-left: 0; padding-right: 0">
                  <el-icon class="el-icon--right"><arrow-down /></el-icon
                ></span>
              </div>

              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item
                    command="outstanding"
                    :disabled="regroupOutstanding_disable"
                    >Regroup with Outstanding</el-dropdown-item
                  >
                  <el-dropdown-item command="newschedule"
                    >Regroup to New Schedule</el-dropdown-item
                  >
                </el-dropdown-menu>
              </template>
            </el-dropdown>
            <base-checkbox
              style="margin-top: 0rem; display: inline; padding-left: 15px"
              v-model="paymentScheduleForm.specialSetting"
              v-if="paymentScheduleForm.paymentType === 'installment'"
              :disabled="
                type == 'view' ||
                specialSetting_disable ||
                useContract.getContractFunctionPermission('SpecialSetting')
                  ?.disable
              "
              >Special Setting</base-checkbox
            >
          </div>
        </div>
        <div
          style="
            padding-top: 10px;
            padding-bottom: 5px;
            border-bottom: solid 1px #e3e3e3;
            min-height: 36px;
          "
        >
          <base-button
            type="primary"
            v-if="isAddSchedule"
            :disabled="type === 'view'"
            link
            class="base-icon-button"
            @click="addSchedule"
          >
            <span class="icon-button add" style="margin-right: 10px">
              <i
                color="#fff"
                class="matrix-icon-add"
                style="font-size: 10px; vertical-align: middle"
              >
              </i>
            </span>
            Add Schedule</base-button
          >
        </div>

        <el-table
          :data="scheduleData"
          class-name="schedule-table"
          :row-class-name="RowClassNameHandler"
          :header-cell-class-name="SetCellClass"
          :cell-class-name="SetCellBackGround"
        >
          <el-table-column width="50">
            <template slot-scope="scope"> </template>
          </el-table-column>
          <el-table-column width="30">
            <template #default="prop">
              <base-checkbox
                v-if="
                  !prop.row.isTotal &&
                  prop.row?.invoiceStatus !== 'invoiced' &&
                  props.type !== 'view' &&
                  prop.row.schedule.toString().indexOf('Deposit') < 0
                "
                @click="
                  (event) =>
                    selectForBulk(prop.row, event.target.checked, event.target)
                "
                v-model="prop.row.checked"
                >&nbsp;</base-checkbox
              >
            </template>
          </el-table-column>
          <el-table-column label="Schedule" min-width="70" prop="schedule" />
          <el-table-column
            label="From"
            min-width="80"
            prop="from"
            :formatter="FormatterDate"
            ><template #default="scope">
              <base-input
                v-if="
                  paymentScheduleForm.specialSetting &&
                  scope.row.invoiceStatus !== 'invoiced' &&
                  scope.$index !== scheduleData.length - 1 &&
                  type != 'view'
                "
              >
                <el-date-picker
                  v-model="scope.row.from"
                  type="date"
                  style="border: 0px"
                  format="DD/MM/YYYY"
                  value-format="YYYY-MM-DD"
                  class="form-group date"
                  :defaultValue="
                    new Date(
                      scope.row.to ?? paymentScheduleForm.campaignPeriod[0]
                    )
                  "
                  :class="{
                    'has-error': scope.row?.validate
                      ?.map((t) => t?.field)
                      .includes('from'),
                  }"
                  :disabled-date="
                    (val) =>
                      disabledDate_Sub(
                        val,
                        paymentScheduleForm.campaignPeriod,
                        scope.$index,
                        'end'
                      )
                  "
                  @change="changePsdPeriod(scope.$index, 'from')"
                >
                </el-date-picker>
              </base-input> </template
          ></el-table-column>
          <el-table-column
            label="To"
            min-width="80"
            prop="to"
            :formatter="FormatterDate"
            ><template #default="scope">
              <base-input
                v-if="
                  paymentScheduleForm.specialSetting &&
                  scope.row.invoiceStatus !== 'invoiced' &&
                  scope.$index !== scheduleData.length - 1 &&
                  type != 'view'
                "
              >
                <el-date-picker
                  v-model="scope.row.to"
                  type="date"
                  style="border: 0px"
                  format="DD/MM/YYYY"
                  value-format="YYYY-MM-DD"
                  :defaultValue="
                    new Date(
                      scope.row.from ?? paymentScheduleForm.campaignPeriod[0]
                    )
                  "
                  class="form-group date"
                  :class="{
                    'has-error': scope.row?.validate
                      ?.map((t) => t?.field)
                      .includes('to'),
                  }"
                  :disabled-date="
                    (val) =>
                      disabledDate_Sub(
                        val,
                        paymentScheduleForm.campaignPeriod,
                        scope.$index,
                        'start'
                      )
                  "
                  @change="changePsdPeriod(scope.$index, 'to')"
                >
                </el-date-picker>
              </base-input> </template
          ></el-table-column>
          <el-table-column
            :label="getNumberOfTitle()"
            min-width="35"
            prop="days"
          />
          <el-table-column
            label="Installment(Media)"
            class-name="text-right"
            min-width="140"
            prop="mediaAmount"
            :formatter="FormatterMoney"
            ><template #default="scope">
              <base-input
                v-if="
                  paymentScheduleForm.specialSetting &&
                  scope.row.invoiceStatus !== 'invoiced' &&
                  props.activeName !== 'production' &&
                  scope.$index !== scheduleData.length - 1 &&
                  type != 'view'
                "
                v-model="scope.row.mediaAmount"
                @change="changePsDetailMoney(scope.$index, 'media')"
                :class="{
                  'has-error': scope.row?.validate
                    ?.map((t) => t?.field)
                    .includes('mediaAmount'),
                }"
              >
              </base-input> </template
          ></el-table-column>
          <el-table-column
            label="Installment(Production)"
            class-name="text-right"
            min-width="140"
            prop="productionAmount"
            :formatter="FormatterMoney"
          >
            <template #default="scope">
              <base-input
                v-if="
                  paymentScheduleForm.specialSetting &&
                  scope.row.invoiceStatus !== 'invoiced' &&
                  props.activeName !== 'media' &&
                  scope.$index !== scheduleData.length - 1 &&
                  type != 'view'
                "
                v-model="scope.row.productionAmount"
                @change="changePsDetailMoney(scope.$index, 'production')"
                :class="{
                  'has-error': scope.row?.validate
                    ?.map((t) => t?.field)
                    .includes('productionAmount'),
                }"
              ></base-input> </template
          ></el-table-column>
          <el-table-column
            label="Total Amount"
            class-name="text-right"
            min-width="140"
            prop="totalAmount"
            :formatter="FormatterMoney"
          />
          <el-table-column
            label="Payment Due"
            min-width="80"
            prop="paymentDueDate"
            :formatter="FormatterDate"
          >
            <template #default="scope">
              <base-input
                v-if="
                  paymentScheduleForm.specialSetting &&
                  scope.row.invoiceStatus !== 'invoiced' &&
                  scope.$index !== scheduleData.length - 1 &&
                  type != 'view'
                "
                :class="{
                  'has-error': scope.row?.validate
                    ?.map((t) => t?.field)
                    .includes('paymentDueDate'),
                }"
              >
                <el-date-picker
                  v-model="scope.row.paymentDueDate"
                  type="date"
                  style="border: 0px"
                  format="DD/MM/YYYY"
                  value-format="YYYY-MM-DD"
                  class="form-group date"
                  @change="changePaymentDue(scope.$index)"
                >
                </el-date-picker>
              </base-input>
            </template>
          </el-table-column>
          <el-table-column
            label="INV Issue Date"
            min-width="80"
            prop="invoiceDate"
            :formatter="FormatterDate"
          >
            <template #default="scope">
              <base-input
                v-if="
                  paymentScheduleForm.specialSetting &&
                  scope.row.invoiceStatus !== 'invoiced' &&
                  scope.$index !== scheduleData.length - 1 &&
                  type != 'view'
                "
                :class="{
                  'has-error': scope.row?.validate
                    ?.map((t) => t?.field)
                    .includes('invoiceDate'),
                }"
              >
                <el-date-picker
                  v-model="scope.row.invoiceDate"
                  type="date"
                  style="border: 0px"
                  format="DD/MM/YYYY"
                  value-format="YYYY-MM-DD"
                  class="form-group date"
                  :disabled-date="
                    (val) =>
                      disabledDate_Sub(
                        val,
                        [null, scope.row.paymentDueDate],
                        scope.$index,
                        'due'
                      )
                  "
                  @change="changePsdInvoiceDate(scope.$index)"
                >
                </el-date-picker>
              </base-input>
            </template>
          </el-table-column>
          <el-table-column
            label="Payment Status"
            min-width="70"
            prop="paymentStatus"
          >
            <template #default="scope">
              <el-row style="padding-bottom: 0px">
                <el-col :span="20">
                  {{ FormatterPaymentStatus('', '', scope.row.paymentStatus) }}
                </el-col>
                <el-col
                  :span="4"
                  v-if="
                    Object.keys(scope.row).indexOf('schedule') >= 0 &&
                    scope.row.invoiceStatus !== 'invoiced'
                  "
                >
                  <el-dropdown :disabled="type === 'view'">
                    <span>
                      <el-icon>
                        <MoreFilled class="rotate" />
                      </el-icon>
                    </span>
                    <template #dropdown>
                      <el-dropdown-menu>
                        <el-dropdown-item
                          command="Set as Immediately"
                          @click="scope.row.paymentStatus = 'immediately'"
                          >Set as Immediately</el-dropdown-item
                        >
                        <el-dropdown-item
                          command="Cancel set Immediately"
                          @click="scope.row.paymentStatus = 'onschedule'"
                          >Cancel set Immediately</el-dropdown-item
                        >
                      </el-dropdown-menu>
                    </template>
                  </el-dropdown>
                </el-col>
              </el-row>
            </template>
          </el-table-column>
          <el-table-column
            label="Invoice Status"
            min-width="70"
            class-name="orange-text"
            prop="invoiceStatus"
          >
            <template slot-scope="scope" #default="prop">
              {{ displayInvoiceStatus(prop.row.invoiceStatus) }}
            </template>
          </el-table-column>
          <el-table-column min-width="60">
            <template #default="scope">
              <el-button
                round
                style="background: #3182ce; color: #fff"
                v-if="Object.keys(scope.row).indexOf('schedule') >= 0"
                @click="InvoiceClick(scope.row.id, scope.row.invID,scope.row.paymentDetail_Id)"
                :disabled="scope.row.invoiceStatus !== 'invoiced'"
              >
                Invoice
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-dropdown
          v-if="paymentScheduleForm.paymentType === 'installment'"
          :disabled="type == 'view'"
          trigger="click"
          class="round-dropdown"
          style="margin-top: 20px"
          @command="BulkActionHandler"
        >
          <span class="arrow-down">
            Bulk Action
            <!-- <el-icon><CaretBottom /></el-icon> -->
          </span>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item
                command="breakEven"
                :disabled="paymentScheduleForm.paymentType !== 'installment'"
                >Recal Break Even</el-dropdown-item
              >
              <el-dropdown-item
                :disabled="paymentScheduleForm.paymentType !== 'installment'"
                command="delete"
                >Delete</el-dropdown-item
              >
              <el-dropdown-item
                :disabled="paymentScheduleForm.paymentType !== 'installment'"
                command="merge"
                >Recal Merge</el-dropdown-item
              >
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script setup>
import baseInput from '@/components/newUI/Inputs/BaseInput';
import baseButton from '@/components/newUI/BaseButton';
import baseRadio from '@/components/newUI/Inputs/BaseRadio';
import baseCheckbox from '@/components/newUI/Inputs/BaseCheckbox';
import moneyInput from '@/components/newUI/Inputs/MoneyInput';
import { Warning, MoreFilled, ArrowDown } from '@element-plus/icons-vue';
import { requestFromAWS } from '@/utilFunction';
import { nextTick, reactive, ref, watch, onMounted, defineProps } from 'vue';
import { usePaymentScheduleStore } from '@/store/paymentSchedule';
import { useAuthorityStore } from '@/store/authority';
import { useContractStore } from '@/store/contract';
import { useContractInfoStore } from '@/store/contractinfo';
import { ElMessage, ElMessageBox } from 'element-plus';
import { storeToRefs } from 'pinia';
import { v4 as uuidv4 } from 'uuid';
import validation from '@/assets/js/validation.js';
const installment = require('./installment');

const util = require('@/utilFunction');
const dateJs = require('@/assets/js/date').default;

var props = defineProps([
  'status',
  'save',
  'type',
  'saveData',
  'prepareToSave',
  'isMAndP',
  'activeName',
  'payment_id',
]);

const useContract = useContractStore();
const { bHasRevise } = storeToRefs(useContract);

const usePaymentSchedule = usePaymentScheduleStore();
const { PaymentScheduleSummary } = storeToRefs(usePaymentSchedule);

var specialTerms = ref(false);
var numberOfSchedule = ref(0);
const installmentMode = ref('day');
const splitPref = ref('ssd');
const installmentTitle = ref('Installment (pre Months)');
const GenerateScheduleData = ref([]);
//const showOutstanding = ref(false);
const OutstandingMediaAmount = ref(0);
const OutstandingProductionAmount = ref(0);

var paymentScheduleForm = reactive({
  campaignPeriod: [],
  mediaTotal: 0,
  productionTotal: 0,
  mediaOutstanding: 0,
  productionOutstanding: 0,
  description: '',
  psNo: '',
});
var invoiceTerm = ref([]);
var paymentTerm = ref([]);
var paymentType = reactive([]);
var initCampaign = {};
var disableCampaignDate = ref([]); // 禁用日期
var scheduleData = ref([]);
var isNew = ref(false);
var isPrivate = ref(false);
var isGovernment = ref(false);
var isCOD = false;
var isSpecial = ref(false);
var paymentSchedule;
var businessNature;
var clientType;
var oneMonthDays = 30;
const fixDate = ref(1);
const isFixDate = ref(false);
const installmentNumberOf = ref(1);
const earlyDeposit = ref(0);
var numberOfScheduleRecord = 0;
const scheduleDataMedia = ref([]);
const scheduleDataProduction = ref([]);
const payment_id = ref();
var bEnablePaymentTerm = ref(false);
var bEnableInvoiceTerm = ref(false);
const SpecialPayDays = ref(1);
var voidPaymentDetails = ref([]);
const watchAmount = ref(false);
var shouldUpdate = true;
var selectedSchedule = [];
var dialogNewType = ref(''); //用于处理regroup with New Schedule
var regroupNewScheduleData = ref(null); //regroup new schedule存储原有数据
var regroupData = ref(null); // regroup 计算的参数
var regroup_disable = ref(true); //regroup 置灰状态
var regroupOutstanding_disable = ref(true); //regroup 置灰状态
var reviseUpdate_disable = ref(false); // reviseUpdate 置灰状态
var scheduleSetting_disable = ref(false); // New Payment Schedule > Schedule Setting 置灰状态
var info_disable = ref(true); // New Payment Schedule > Information置灰状态, 默认禁用
var isChangedPeriod = ref(false); //媒体周期是否改变状态
var BulkDelete_disable = ref(true); //是否Bulk Action > Delete置灰状态
var regenerate_disable = ref(false); //【Regenerate】按钮置灰状态
var isAddSchedule = ref(false); //是否新增计划
var paymentTerm_disable = ref(false); //付款条件置灰状态，默认启用
var specialTerms_disable = ref(false); //特殊付款条件置灰状态，默认启用
var fixDate_disable = ref(false); //固定日期置灰状态，默认启用
var specialSetting_disable = ref(false); //特殊设置置灰状态，默认启用

//var endpoint = 'https://zmiz6zzxtv5ug4r4jdled22jg40fpgrj.lambda-url.ap-east-1.on.aws';

var specialTerm = reactive({});

//requestFromAWS(endpoint,'getTesting');

function checkForPaymentDue(e) {
  if (typeof e !== 'undefined') {
    isFixDate.value = e;
    if (!isFixDate.value) {
      GenerateScheduleData.value = GenerateScheduleData.value.concat(
        scheduleData.value.filter(
          (t) => t.id > 0 && t.invoiceStatus !== 'invoiced'
        )
      );

      scheduleData.value = scheduleData.value.filter(
        (t) => t.invoiceStatus === 'invoiced'
      );
    }
  }

  if (!isFixDate.value) {
    fixDate.value = 1;
  }

  changeFixofMonth();
  console.log(isFixDate.value);
}

function selectForBulk(row, e, target) {
  if (typeof e === 'undefined') {
    return;
  }
  row.target = target;
  if (e) {
    selectedSchedule.push(row);
  } else {
    selectedSchedule = selectedSchedule.filter(
      (t) => t.schedule !== row.schedule
    );
  }

  console.log(selectedSchedule);
}
const BulkActionHandler = (action) => {
  switch (action) {
    case 'breakEven':
      breakEven();
      break;
    case 'delete':
      deleteBulk();
      break;
    case 'merge':
      mergeSchedule();
      break;
  }
  if (
    paymentScheduleForm.paymentType === 'installment' &&
    action !== 'delete'
  ) {
    paymentScheduleForm.specialSetting = true;
  }
};
function breakEven() {
  if (scheduleData.value.filter((t) => t.checked).length < 2) {
    ElMessage({
      message: 'Please select at least 2 schedules.',
      type: 'warning',
    });
    return;
  }

  var message =
    scheduleData.value.find(
      (t) => t.checked && t?.validate && t?.validate.length > 0
    )?.validate?.[0]?.message || '';
  if (message) {
    ElMessage({
      message,
      type: 'warning',
    });
    return;
  }

  var tempIn = installment.breakEven(
    selectedSchedule,
    scheduleData.value,
    props.activeName
  );
  scheduleData.value = tempIn;

  // selectedSchedule.map((val) => {
  //   val.target.checked = false;
  // });
  selectedSchedule = [];
}

function deleteBulk() {
  if (scheduleData.value.filter((t) => t.checked).length === 0) {
    ElMessage({
      message: 'Please select schedule.',
      type: 'warning',
    });
    return;
  }

  ElMessageBox.confirm(
    'Are you sure you want to delete the schedule(s)?',
    'Delete Schedule(s)',
    {
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
      customClass: 'matrix-message-box',
      confirmButtonClass: 'right-confirm-1',
    }
  ).then(() => {
    GenerateScheduleData.value = GenerateScheduleData.value.concat(
      scheduleData.value.filter((t) => t.id > 0 && t.checked)
    );

    scheduleData.value = scheduleData.value.filter((t) => !t.checked);
    scheduleData.value
      .filter(
        (t) =>
          (t?.schedule?.toString() ?? '').indexOf('Deposit') < 0 && !t.isTotal
      )
      .map((t, index) => (t.schedule = index + 1));

    if (paymentScheduleForm.paymentType === 'installment') {
      ValidateCampaignPeriodv2();
      paymentScheduleForm.specialSetting = true;
    }

    // 更新Total Record
    watchAmount.value = true;

    selectedSchedule = [];
  });
}

function mergeSchedule() {
  if (scheduleData.value.filter((t) => t.checked).length < 2) {
    ElMessage({
      message: 'Please select at least 2 schedules.',
      type: 'warning',
    });
    return;
  }

  var message =
    scheduleData.value.find(
      (t) => t.checked && t?.validate && t?.validate.length > 0
    )?.validate?.[0]?.message || '';
  if (message) {
    ElMessage({
      message,
      type: 'warning',
    });
    return;
  }

  var mergeScheduleDatas = [
    ...scheduleData.value.filter(
      (t) =>
        t.invoiceStatus !== 'invoiced' &&
        (t?.schedule?.toString() || '').indexOf('Deposit') < 0
    ),
  ];

  var tempIn = installment.mergeSchedule(
    selectedSchedule,
    mergeScheduleDatas,
    props.activeName,
    installmentNumberOf.value
  );
  var paymentDue = '';
  var lastMonth = 0;
  var lastYear = 0;
  tempIn.map((val, index) => {
    if (val.isTotal) {
      return;
    }
    if (val.no == ' ') {
      paymentDue = new Date();
      tempIn[index].paymentDueDate = paymentDue;
    } else {
      if (isFixDate.value) {
        paymentDue = installment.getFixDueDate(
          val.from,
          fixDate.value,
          lastMonth,
          lastYear
        );
        tempIn[index].paymentDueDate = paymentDue;
        if (paymentDue) {
          lastMonth = paymentDue.getMonth() + 1;
          lastYear = paymentDue.getFullYear();
        }
      } else {
        if (val.from && val.to) {
          paymentDue = getDueDate(
            paymentScheduleForm.paymentTerm,
            val.from,
            val.to,
            '',
            '',
            specialTerm
          );
          tempIn[index].paymentDueDate = paymentDue;
        }
      }
    }
    if (tempIn[index].paymentDueDate) {
      tempIn[index].paymentDueDate = dateJs.ConvertDate(
        tempIn[index].paymentDueDate
      );
      tempIn[index].paymentStatus =
        dateDiffInDays(new Date(), new Date(tempIn[index].paymentDueDate)) > 30
          ? 'onschedule'
          : 'immediately';
      tempIn[index].invoiceDate = getDueDate(
        paymentScheduleForm.invoiceTerm,
        val.from,
        val.to,
        paymentDue,
        'invoice'
      );
    }
  });

  var oldPaymentDetail_Ids = scheduleData.value
    .map((t) => t?.paymentDetail_Id ?? '')
    .filter((t) => t);
  var mergePaymentDetail_Ids = tempIn
    .map((t) => t?.paymentDetail_Id ?? '')
    .filter((t) => t);

  if (oldPaymentDetail_Ids.length > 0) {
    var removePaymentDetail_Ids = oldPaymentDetail_Ids.filter(
      (t) => !mergePaymentDetail_Ids.includes(t)
    );
    GenerateScheduleData.value = GenerateScheduleData.value.concat(
      scheduleData.value.filter(
        (t) =>
          t.id > 0 &&
          removePaymentDetail_Ids.includes(t.paymentDetail_Id) &&
          t.schedule.toString().indexOf('Deposit') < 0 &&
          t.invoiceStatus !== 'invoiced'
      )
    );
  }

  scheduleData.value = scheduleData.value
    .filter(
      (t) =>
        t.invoiceStatus == 'invoiced' ||
        (t?.schedule?.toString() ?? '').indexOf('Deposit') >= 0
    )
    .concat(tempIn);

  selectedSchedule.map((val) => {
    val.target.checked = false;
  });
  selectedSchedule = [];
}

function dateDiffInDays(a, b) {
  console.log(a, b);
  if (typeof a === 'string' || a instanceof String) {
    a = new Date(util.getJSDate(a));
    b = new Date(util.getJSDate(b));
  }
  const _MS_PER_DAY = 1000 * 60 * 60 * 24;
  // Discard the time and time-zone information.
  const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
  const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

  return Math.floor((utc2 - utc1) / _MS_PER_DAY) + 1;
}

function dateDiffInDaysTerms(a, b) {
  a = new Date(a);
  b = new Date(b);

  const _MS_PER_DAY = 1000 * 60 * 60 * 24;
  // Discard the time and time-zone information.
  const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
  const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

  console.log('dateDiffInDaysTerms', Math.floor((utc2 - utc1) / _MS_PER_DAY));

  return Math.floor((utc2 - utc1) / _MS_PER_DAY);
}

function updateNumberOfSchedule(value) {
  numberOfSchedule.value = value;
}
function updateNumberOfSchedulev2() {
  updateNumberOfSchedule(
    dateDiffInDays(
      paymentScheduleForm.campaignPeriod[0],
      paymentScheduleForm.campaignPeriod[1]
    )
  );
}

function getNumberOfTitle() {
  if (paymentScheduleForm.paymentType == 'installment') {
    return installmentMode.value == 'month' ? 'Months' : 'Days';
  } else {
    return 'Days';
  }
}

function isCodState(date, date1) {
  date = date || new Date();
  if (!date1) {
    return false;
  }
  return dateDiffInDaysTerms(date, date1) + 1 <= oneMonthDays;
}

// onMounted(() => {
//     const paymentSchedule = usePaymentScheduleStore();
//     var temp = paymentSchedule.getSummary();
//     paymentScheduleForm.campaignPeriod = temp.campaignPeriod;
//     paymentScheduleForm.mediaTotal = temp.mediaTotal;
//     paymentScheduleForm.productionTotal = temp.productionTotal;
//     paymentScheduleForm.grandTotal = paymentScheduleForm.mediaTotal + paymentScheduleForm.productionTotal;
//     console.log(paymentScheduleForm.campaignPeriod);
//     console.log(props.status);
//     //console.log(paymentSchedule.getSummary());
// });

const resetTermEnable = (value, type) => {
  if (!value?.toString()) {
    var paymentsettings = usePaymentSchedule.PaymentTermSettings;
    if (type === 'invoice') {
      paymentsettings = usePaymentSchedule.InvoiceTermSettings;
    }
    var settings1 = paymentsettings.filter(
      (t) =>
        !t.PaymentType &&
        t.PaymentType !== '' &&
        !t.NaturePermission &&
        t.NaturePermission !== '' &&
        !t.Keyword &&
        t.Keyword !== ''
    );
    var settings2 = paymentsettings.filter(
      (t) =>
        ((!t.PaymentType && t.PaymentType !== '') ||
          t.PaymentType === paymentScheduleForm.paymentType) &&
        ((!t.NaturePermission && t.NaturePermission !== '') ||
          t.NaturePermission.indexOf(businessNature) >= 0) &&
        ((!t.Keyword && t.Keyword !== '') ||
          paymentScheduleForm.keyword.indexOf(t.Keyword) >= 0)
    );

    var settings = settings1.concat(settings2);

    value =
      settings?.length === 0 ||
      (settings.length === 1 && settings[0].AllowChanges);
  }
  console.log(
    value,
    type,
    paymentsettings,
    12332111111,
    usePaymentSchedule.PaymentTermSettings,
    22222222,
    usePaymentSchedule.InvoiceTermSettings,
    66666,
    settings1,
    77777,
    settings2,
    33333,
    444444,
    specialTerms.value
  );
  return value;
};

function init() {
  const ContractInfoT = useContractInfoStore().Contract;
  scheduleData.value = [];
  paymentSchedule = usePaymentScheduleStore();

  var temp = paymentSchedule.getSummary();
  var paymentScheduleData = paymentSchedule.getPaymentSchedule(
    payment_id.value
  );

  // FixDate
  if (paymentScheduleData?.FixDate) {
    var fixData = JSON.parse(paymentScheduleData.FixDate);
    if (fixData && fixData.isFixDate) {
      isFixDate.value = fixData.isFixDate;
      fixDate.value = fixData.fixDate;
    }
  }

  disableCampaignDate.value = [
    temp.campaignPeriodStart,
    temp.campaignPeriodEnd,
  ];

  if (props.activeName !== 'production') {
    if (paymentScheduleData?.Id > 0) {
      OutstandingMediaAmount.value = parseFloat(
        temp.totalOutstandingMediaAmount
      );
    }
  }

  if (props.activeName !== 'media') {
    if (paymentScheduleData?.Id > 0) {
      OutstandingProductionAmount.value = parseFloat(
        temp.totalOutstandingProductionAmount
      );
    }
  }

  var specialPaymentTerm = paymentSchedule.getSpecialPaymentTerm(
    payment_id.value
  );

  specialTerms.value = specialPaymentTerm != null;
  if (specialTerms.value) {
    specialTerm = specialPaymentTerm;
    SpecialPayDays.value = specialTerm.Days || 1;
  }

  paymentScheduleForm.id = paymentScheduleData?.Id || 0;
  // Contract Draft No
  paymentScheduleForm.contractDraftNo =
    paymentScheduleData?.contractDraftNo || '';
  if (paymentScheduleForm.contractDraftNo === '') {
    if (
      props.activeName === 'media' ||
      props.activeName === 'media+production'
    ) {
      paymentScheduleForm.contractDraftNo = JSON.stringify([
        ContractInfoT.contractDraftNoMedia,
      ]);
    } else {
      paymentScheduleForm.contractDraftNo = JSON.stringify([
        ContractInfoT.contractDraftNoProduction,
      ]);
    }
  }

  // PsNo
  paymentScheduleForm.psNo = paymentScheduleData?.PSNo || '';
  // Payment Period
  //console.log(paymentSchedule);
  var mediaTemp = JSON.parse(paymentSchedule.contractMedia);
  //console.log(installment.findLastEndDateExcludeBonus(mediaTemp));
  paymentScheduleForm.campaignPeriod = [
    paymentScheduleData?.CampaignPeriodStart || temp.campaignPeriodStart,
    paymentScheduleData?.CampaignPeriodEnd || temp.campaignPeriodEnd,
  ];
  initCampaign = paymentScheduleForm.campaignPeriod;

  // Schedule Media Amount
  var mediaTotal = paymentScheduleData?.ScheduleMediaAmount;
  paymentScheduleForm.beforeMediaTotal = mediaTotal || 0;

  if (
    (props.activeName || '') !== 'production' &&
    !mediaTotal &&
    !paymentScheduleData
  ) {
    mediaTotal = PaymentScheduleSummary.value.totalOutstandingMediaAmount;
  }
  paymentScheduleForm.mediaTotal = `$ ${FormatterMoneyInput(mediaTotal || 0)}`;

  // Schedule Production Amount
  var productionTotal = paymentScheduleData?.ScheduleProductionAmount || 0;
  paymentScheduleForm.beforeProductionTotal = productionTotal;
  if (
    (props.activeName || '') !== 'media' &&
    !productionTotal &&
    !paymentScheduleData
  ) {
    productionTotal =
      PaymentScheduleSummary.value.totalOutstandingProductionAmount;
  }
  paymentScheduleForm.productionTotal = `$ ${productionTotal || 0}`;

  paymentScheduleForm.contractType = temp.contractType;
  // paymentScheduleForm.grandTotal =
  //   (paymentScheduleForm.mediaTotal || 0) +
  //   (paymentScheduleForm.productionTotal || 0);
  paymentScheduleForm.paymentType =
    paymentScheduleData?.PSType || 'fullpayment';
  //earlyDeposit.value = keyword?.earlyDeposit || 0;
  paymentScheduleForm.description = paymentScheduleData?.Description || '';
  paymentScheduleForm.businessNature =
    paymentScheduleData?.BusinessNature || paymentSchedule.getBusinessNature();

  //invoiceTerm = paymentSchedule.getInvoiceTerm();
  //paymentTerm = paymentSchedule.getPaymentTerm();
  paymentType = paymentSchedule.getPaymentType();
  businessNature = paymentScheduleForm.businessNature;
  clientType = getOrderClientType();
  isPrivate.value = businessNature == 'Private';
  isGovernment.value = businessNature == 'Government' && clientType === 'DC';

  var date = paymentScheduleData?.UpdateDate || new Date();
  isCOD = dateDiffInDaysTerms(date, initCampaign[0]) + 1 <= oneMonthDays;

  paymentScheduleForm.keyword = paymentScheduleData?.Keyword;
  if (!paymentScheduleForm.keyword) {
    paymentScheduleForm.keyword = JSON.stringify(
      Object.values(usePaymentSchedule.getPaymentKeywords()?.[0] || [])
    );
  }
  paymentScheduleForm.specialSetting = paymentScheduleData?.SpecialSetting;
  console.log(paymentScheduleForm.keyword);

  var Keyword = JSON.parse(paymentScheduleForm.keyword);
  Keyword.map((val) => {
    if (isNaN(val) && val.indexOf('earlyDeposit') != -1) {
      earlyDeposit.value = val.split(':')[1];
      shouldUpdate = false;
    }
    if (isNaN(val) && val.indexOf('dayPerInstallment') != -1) {
      installmentNumberOf.value = val.split(':')[1];
      shouldUpdate = false;
    }
  });

  // Payment Term
  if (!isFixDate.value) {
    paymentTerm.value = getPaymentScheduleTerms(
      paymentScheduleForm.paymentType,
      businessNature,
      Keyword
    );
  }

  paymentScheduleForm.paymentTerm = NewPaymentTerm(
    paymentScheduleData?.PaymentTerm
  );

  invoiceTerm.value = getPaymentScheduleTerms(
    paymentScheduleForm.paymentType,
    businessNature,
    Keyword,
    'invoice'
  );

  paymentScheduleForm.invoiceTerm = NewPaymentTerm(
    paymentScheduleData?.InvoiceTerm,
    'invoice'
  );

  // 更新Campaign Period状态(只初始化更新)
  isChangedPeriod.value =
    props.type !== 'view' &&
    paymentScheduleForm.psNo &&
    (new Date(disableCampaignDate.value[0]).getTime() !==
      new Date(paymentScheduleForm.campaignPeriod[0]).getTime() ||
      new Date(disableCampaignDate.value[1]).getTime() !==
        new Date(paymentScheduleForm.campaignPeriod[1]).getTime());

  if (props.type != 'new') {
    //var tempScheduleData = paymentSchedule.getPaymentScheduleData();
    var tempScheduleData = paymentScheduleData;

    if (tempScheduleData) {
      // paymentScheduleForm.paymentType = tempScheduleData?.[0].PSType;
      // paymentScheduleForm.paymentTerm = tempScheduleData?.[0].PaymentTerm;
      // paymentScheduleForm.invoiceTerm = tempScheduleData?.[0].InvoiceTerm;

      //if (props.isMAndP) {
      // var contractActionData;
      // let totalRecord = {};
      // if (props.activeName == 'media') {
      //   contractActionData = tempScheduleData.filter((val) => {
      //     return val.ContractAction == 'media';
      //   });
      //   totalRecord.mediaAmount = util.getMoneyFormat(
      //     paymentScheduleForm.mediaTotal || 0
      //   );
      //   totalRecord.productionAmount = util.getMoneyFormat(0);
      //   totalRecord.totalAmount = util.getMoneyFormat(
      //     paymentScheduleForm.mediaTotal || 0
      //   );
      // }
      // if (props.activeName == 'production') {
      //   contractActionData = tempScheduleData.filter((val) => {
      //     return val.ContractAction == 'production';
      //   });
      //   totalRecord.mediaAmount = util.getMoneyFormat(0);
      //   totalRecord.productionAmount = util.getMoneyFormat(
      //     paymentScheduleForm.productionTotal || 0
      //   );
      //   totalRecord.totalAmount = util.getMoneyFormat(
      //     paymentScheduleForm.productionTotal || 0
      //   );
      // }
      // if (contractActionData[0].PaymentDetail) {
      //   contractActionData[0].PaymentDetail.map((val) => {
      //     var temp = {};
      //     temp.no = val.PeriodNo;
      //     temp.schedule = val.PeriodNo;
      //     temp.from = util.getDateFormat(val.PaymentFrom);
      //     temp.to = util.getDateFormat(val.PaymentTo);
      //     temp.days = val.NoOfDays;
      //     temp.mediaAmount = util.getMoneyFormat(
      //       val.MediaInstallmentAmount || 0
      //     );
      //     temp.productionAmount = util.getMoneyFormat(
      //       val.ProductionInstallmentAmount || 0
      //     );
      //     temp.totalAmount = util.getMoneyFormat(val.TotalAmount || 0);
      //     temp.paymentDueDate = util.getDateFormat(val.PaymentDueDate);
      //     temp.invoiceDate = util.getDateFormat(val.InvoiceIssueDate);
      //     temp.paymentStatus = val.PaymentStatus;
      //     temp.invoiceStatus = val.InvoiceStatus;
      //     scheduleData.value.push(temp);
      //   });
      // }
      // totalRecord.isTotal = true;
      // scheduleData.value.push(totalRecord);
      //} else {
      if (tempScheduleData?.PaymentDetail) {
        var paymentDetails = tempScheduleData.PaymentDetail.sort(
          (a, b) => a.PeriodNo - b.PeriodNo
        );

        paymentDetails.map((val) => {
          var temp = {};
          temp.id = val.Id;
          temp.paymentDetail_Id = val.UniqueId;
          temp.no = val.PeriodNo;
          temp.schedule = val.PeriodNoName;
          temp.from = val.PaymentFrom;
          temp.to = val.PaymentTo;
          temp.days = val.NoOfDays;
          temp.mediaAmount = val.MediaInstallmentAmount;
          temp.productionAmount = val.ProductionInstallmentAmount;
          temp.totalAmount = val.TotalAmount;
          temp.paymentDueDate = val.PaymentDueDate;
          temp.invoiceDate = val.InvoiceIssueDate;
          temp.paymentStatus = val.PaymentStatus;
          temp.invoiceStatus = val.InvoiceStatus;
          temp.invID = val.invID;
          scheduleData.value.push(temp);
        });
      }
      var totalRecord = {};

      totalRecord.mediaAmount =
        paymentScheduleForm.mediaTotal?.moneyFormatToFloat() || 0;
      totalRecord.productionAmount =
        paymentScheduleForm.productionTotal?.moneyFormatToFloat() || 0;
      totalRecord.totalAmount =
        totalRecord.mediaAmount + totalRecord.productionAmount;
      totalRecord.isTotal = true;
      scheduleData.value.push(totalRecord);

      //}
      //scheduleData.value = tempScheduleData[0].PaymentDetail;
    } else {
      scheduleData.value = props.prepareToSave.scheduleData;
      //paymentScheduleForm.value = props.prepareToSave.paymentScheduleForm;
    }

    // 更新Regroup组件状态
    UpdateRegroupDisable();

    // 更新Regroup> Regroup with Outstanding状态
    UpdateRegroupOutstandingDisable();

    // 组件状态更新
    UpdateScheduleDisable();

    UpdateBulkDeleteDisable();

    UpdateSpecialPaymentTermDisable();

    UpdateRegenerateDisable();

    UpdateSpecialSettingDisable();
  }

  // 动态更新Payment Term是否启用
  // var paymentsettings = usePaymentSchedule.PaymentTermSettings;
  // var settings1 = paymentsettings.filter(
  //   (t) =>
  //     !t.PaymentType &&
  //     t.PaymentType !== '' &&
  //     !t.NaturePermission &&
  //     t.NaturePermission !== '' &&
  //     !t.Keyword &&
  //     t.Keyword !== ''
  // );
  // var settings2 = paymentsettings.filter(
  //   (t) =>
  //     ((!t.PaymentType && t.PaymentType !== '') ||
  //       t.PaymentType === paymentScheduleForm.paymentType) &&
  //     ((!t.NaturePermission && t.NaturePermission !== '') ||
  //       t.NaturePermission.indexOf(businessNature) >= 0) &&
  //     ((!t.Keyword && t.Keyword !== '') || Keyword.indexOf(t.Keyword) >= 0)
  // );

  // var settings = settings1.concat(settings2);

  bEnablePaymentTerm.value = resetTermEnable();
  console.log(
    'bEnablePaymentTerm.valuebEnablePaymentTerm.value',
    bEnablePaymentTerm.value
  );

  // 动态更新Payment Term是否启用
  // var invoicesettings = usePaymentSchedule.InvoiceTermSettings;
  // var settings3 = invoicesettings.filter(
  //   (t) =>
  //     !t.PaymentType &&
  //     t.PaymentType !== '' &&
  //     !t.NaturePermission &&
  //     t.NaturePermission !== '' &&
  //     !t.Keyword &&
  //     t.Keyword !== ''
  // );
  // var settings4 = invoicesettings.filter(
  //   (t) =>
  //     ((!t.PaymentType && t.PaymentType !== '') ||
  //       t.PaymentType === paymentScheduleForm.paymentType) &&
  //     ((!t.NaturePermission && t.NaturePermission !== '') ||
  //       t.NaturePermission.indexOf(businessNature) >= 0) &&
  //     ((!t.Keyword && t.Keyword !== '') || Keyword.indexOf(t.Keyword) >= 0)
  // );

  // var settings_invoice = settings3.concat(settings4);
  bEnableInvoiceTerm.value = resetTermEnable(null, 'invoice');
  isNew.value = true;
}

const UpdateScheduleDisable = () => {
  if (
    props.type === 'new' ||
    props.type === 'view' ||
    regroupData.value?.action === 'newschedule'
  ) {
    reviseUpdate_disable.value = true;
    return;
  }

  if (
    scheduleData.value.filter((t) => t.invoiceStatus === 'invoiced').length > 0
  ) {
    // scheduleSetting_disable
    scheduleSetting_disable.value = true;
    if (paymentScheduleForm.paymentType == 'installment') {
      reviseUpdate_disable.value = true;
      return;
    }
  }

  if (OutstandingMediaAmount.value + OutstandingProductionAmount.value !== 0) {
    reviseUpdate_disable.value = false;
    return;
  }

  if (
    new Date(disableCampaignDate.value[0]).getTime() !==
      new Date(paymentScheduleForm.campaignPeriod[0]).getTime() ||
    new Date(disableCampaignDate.value[1]).getTime() !==
      new Date(paymentScheduleForm.campaignPeriod[1]).getTime()
  ) {
    reviseUpdate_disable.value = false;
    return;
  }
  reviseUpdate_disable.value = true;
};
const UpdateRegroupDisable = (value) => {
  if (props.type === 'view') {
    regroup_disable.value = true;
    return;
  }
  if (value !== undefined) {
    regroup_disable.value = value;
    return;
  }

  if (paymentScheduleForm.paymentType === 'installment') {
    if (
      scheduleData.value.filter((t) => t.invoiceStatus === 'invoiced').length >
      0
    ) {
      regroup_disable.value =
        OutstandingMediaAmount.value + OutstandingProductionAmount.value ===
          0 && !isChangedPeriod.value;
      return;
    }
  }

  regroup_disable.value = true;
};
const UpdateRegroupOutstandingDisable = () => {
  if (paymentScheduleForm.paymentType === 'installment') {
    if (!isChangedPeriod.value) {
      regroupOutstanding_disable.value = false;
      return;
    }

    if (
      scheduleData.value.filter(
        (t) => (t?.schedule?.toString() ?? '').indexOf('Deposit') >= 0
      ).length == 0
    ) {
      if (
        new Date(paymentScheduleForm.campaignPeriod[0]).getTime() ===
        new Date(disableCampaignDate.value[0]).getTime()
      ) {
        regroupOutstanding_disable.value = false;
        return;
      }
    }

    regroupOutstanding_disable.value = true;
  }
};
const UpdatePaymentTermDisable = () => {
  if (props.type === 'view') {
    paymentTerm_disable.value = true;
    return;
  }

  paymentTerm_disable.value = specialTerms.value || isFixDate.value;
};
const UpdateFixDateDisable = () => {
  if (props.type === 'view') {
    fixDate_disable.value = true;
    return;
  }

  fixDate_disable.value =
    specialTerms.value || paymentScheduleForm.specialSetting;
};
const UpdateSpecialPaymentTermDisable = (value) => {
  if (props.type === 'view') {
    specialTerms_disable.value = true;
    return;
  }

  if (
    useContract.getContractFunctionPermission('SpecialPaymentTerm')?.disable
  ) {
    specialTerms_disable.value = true;
    return;
  }

  if (value !== undefined) {
    specialTerms_disable.value = value;
    return;
  }

  specialTerms_disable.value = isFixDate.value;
};
const UpdateBulkDeleteDisable = () => {
  BulkDelete_disable.value = paymentScheduleForm.paymentType === 'fullpayment';
};
const UpdateRegenerateDisable = () => {
  if (props.type === 'view') {
    regenerate_disable.value = true;
    return;
  }
  regenerate_disable.value = !regroup_disable.value;
};
const UpdateSpecialSettingDisable = () => {
  if (paymentScheduleForm.paymentType !== 'installment') {
    specialSetting_disable.value = true;
    return;
  }

  specialSetting_disable.value = isFixDate.value;
};
// 更新明细Total
const UpdateTotalRecord = () => {
  var mediaAmounts = scheduleData.value
    .filter((t) => !t.isTotal)
    .map((t) => parseFloat(t.mediaAmount));
  var productionAmounts = scheduleData.value
    .filter((t) => !t.isTotal)
    .map((t) => parseFloat(t.productionAmount));

  var totalRecord = scheduleData.value.find((t) => t.isTotal);
  if (!totalRecord) {
    scheduleData.value.push({
      isTotal: true,
    });
    totalRecord = scheduleData.value.find((t) => t.isTotal);
  }

  totalRecord.mediaAmount =
    mediaAmounts.length === 0
      ? 0
      : mediaAmounts.reduce((a, b) => (a || 0) + (b || 0));
  //paymentScheduleForm.mediaTotal?.moneyFormatToFloat() || 0;
  totalRecord.productionAmount =
    productionAmounts.length === 0
      ? 0
      : productionAmounts.reduce((a, b) => (a || 0) + (b || 0));
  //paymentScheduleForm.productionTotal?.moneyFormatToFloat() || 0;
  totalRecord.totalAmount =
    (totalRecord.mediaAmount || 0) + (totalRecord.productionAmount || 0);
};
// 数据库实体转换到页面实体信息(付款信息)
const NewPaymentScheduleForSave = (data) => {
  var new_payment_schedule = {};

  const ContractInfoT = useContractInfoStore().Contract;
  paymentSchedule = usePaymentScheduleStore();

  new_payment_schedule.id = data?.Id || 0;
  // Contract Draft No
  new_payment_schedule.contractDraftNo = data?.ContractDraftNo || '';
  // PsNo
  new_payment_schedule.contractAction = data?.ContractAction;
  new_payment_schedule.psNo = data?.PSNo || '';
  new_payment_schedule.campaignStart = data.CampaignPeriodStart;
  new_payment_schedule.campaignEnd = data.CampaignPeriodEnd;
  new_payment_schedule.contractId = data.ContractId;
  new_payment_schedule.currency = data.Currency;
  new_payment_schedule.days = data.NoOfDays;
  // Schedule Media Amount
  new_payment_schedule.scheduleMedia = data?.ScheduleMediaAmount;
  // Schedule Production Amount
  new_payment_schedule.scheduleProduction = data?.ScheduleProductionAmount;
  new_payment_schedule.totalScheduleAmount = data?.TotalScheduleAmount;
  new_payment_schedule.contractType = data.ContractType;
  new_payment_schedule.psType = data?.PSType;
  new_payment_schedule.description = data?.Description || '';
  new_payment_schedule.businessNature = data?.BusinessNature;
  new_payment_schedule.keyword = data?.Keyword;
  new_payment_schedule.paymentTerm = data?.PaymentTerm;
  new_payment_schedule.paymentTermSnap = data?.PaymentTermSnap;
  new_payment_schedule.invoiceTerm = data?.InvoiceTerm;
  new_payment_schedule.invoiceTermSnap = data?.InvoiceTermSnap;
  new_payment_schedule.payment_id = data?.UniqueId;
  new_payment_schedule.specialPaymentTerm = data?.SpecialPaymentTerm;
  new_payment_schedule.numOfSchedule = data?.NoOfSchedule;
  new_payment_schedule.paidAmount = 0;
  new_payment_schedule.specialSetting = data.specialSetting;
  return new_payment_schedule;
};
//数据库实体转换到页面实体信息(付款明细)
const NewScheduleData = (data) => {
  var new_schedule_datas = [];

  if (data?.PaymentDetail) {
    data.PaymentDetail.map((val) => {
      var temp = {};
      temp.id = val.Id;
      temp.paymentDetail_Id = val.UniqueId;
      temp.no = val.PeriodNo;
      temp.schedule = val.PeriodNoName;
      temp.from = val.PaymentFrom;
      temp.to = val.PaymentTo;
      temp.days = val.NoOfDays;
      temp.mediaAmount = val.MediaInstallmentAmount;
      temp.productionAmount = val.ProductionInstallmentAmount;
      temp.totalAmount = val.TotalAmount;
      temp.paymentDue = val.PaymentDueDate;
      temp.paymentDueDate = val.PaymentDueDate;
      temp.invoiceDue = val.InvoiceIssueDate;
      temp.paymentStatus = val.PaymentStatus;
      temp.invoiceStatus = val.InvoiceStatus;
      temp.invID = val.invID;
      temp.payment_id = val.PaymentUniqueId;
      new_schedule_datas.push(temp);
    });
  }
  return new_schedule_datas;
};

const NewPaymentTerm = (value, type) => {
  type = type || 'payment';

  var term = value || '';

  if (!term) {
    if ((!specialTerms.value && type === 'payment') || type === 'invoice') {
      var selectTerms = paymentTerm.value;

      if (type === 'invoice') {
        selectTerms = invoiceTerm.value;
      }

      term =
        (selectTerms.find((t) => t.IsDefault)?.Code ??
          selectTerms?.[0]?.Code) ||
        '';
    }
  }
  return term;
};

function displayStatus(date) {
  if (!date) {
    return '';
  }
  if (dateDiffInDaysTerms(new Date(), util.getJSDate(date)) <= 30) {
    return 'Immediately';
  } else {
    return 'On Schedule';
  }
  // switch(status){
  //     case 'immediately': return 'Immediately';
  //     case 'notinvoiced': return 'Not Invoiced';
  // }
}
function displayInvoiceStatus(status) {
  switch (status) {
    case 'immediately':
      return 'Immediately';
    case 'notinvoiced':
      return 'Not Invoiced';
    case 'invoiced':
      return 'Invoiced';
  }
}

function generateSchedule() {
  if (
    !paymentScheduleForm.campaignPeriod ||
    paymentScheduleForm.campaignPeriod.length != 2
  ) {
    ElMessage({
      message: 'Schedule Period cannot be empty! ',
      type: 'warning',
    });
    return;
  }

  //var scheduleParam = scheduleData.value?.[0] || {};

  GenerateScheduleData.value = GenerateScheduleData.value.concat(
    scheduleData.value.filter((t) => t.id > 0 && t.invoiceStatus !== 'invoiced')
  );

  var invoicedDetail = scheduleData.value.filter(
    (t) => t.invoiceStatus === 'invoiced'
  );
  scheduleData.value = invoicedDetail;

  var FinalPaymentAmount = paymentScheduleForm.grandTotal.moneyFormatToFloat();
  if (scheduleData.value.length > 0) {
    FinalPaymentAmount =
      FinalPaymentAmount -
      scheduleData.value[scheduleData.value.length - 1].totalAmount;
    //scheduleData.value = scheduleData.value.filter((t) => t.invoiceStatus);
  }
  console.log(
    333333333333333,
    paymentScheduleForm.paymentType,
    FinalPaymentAmount,
    paymentScheduleForm.campaignPeriod
  );

  if (
    paymentScheduleForm.paymentType == 'fullpayment' &&
    FinalPaymentAmount > 0
  ) {
    var temp = {};

    var finalMediaTotal = 0;
    var finalProductionTotal = 0;
    if (scheduleData.value.length > 0) {
      finalMediaTotal = scheduleData.value
        .map((t) => t.mediaAmount)
        .reduce((a, b) => a + b);
      finalProductionTotal = scheduleData.value
        .map((t) => t.productionAmount)
        .reduce((a, b) => a + b);
    }

    temp.no = scheduleData.value.length + 1;
    temp.schedule = 1;
    numberOfScheduleRecord = 1;
    temp.from = paymentScheduleForm.campaignPeriod[0];
    temp.to = paymentScheduleForm.campaignPeriod[1];
    temp.days = numberOfSchedule.value;
    temp.mediaAmount =
      (paymentScheduleForm.mediaTotal?.moneyFormatToFloat() || 0) -
      finalMediaTotal;
    temp.productionAmount =
      (paymentScheduleForm.productionTotal?.moneyFormatToFloat() || 0) -
      finalProductionTotal;
    temp.totalAmount = FinalPaymentAmount;
    temp.paymentDueDate = getDueDate(
      paymentScheduleForm.paymentTerm,
      temp.from,
      temp.to,
      '',
      undefined,
      specialTerm
    );

    temp.invoiceDate = getDueDate(
      paymentScheduleForm.invoiceTerm,
      temp.from,
      temp.to,
      temp.paymentDueDate,
      'invoice'
    );
    temp.paymentStatus = 'immediately';
    if (paymentScheduleForm.paymentTerm !== 'cod') {
      //temp.paymentStatus = 'onschedule';
      temp.paymentStatus =
        dateDiffInDays(new Date(), new Date(temp.paymentDueDate)) > 30
          ? 'onschedule'
          : 'immediately';
    }
    temp.invoiceStatus = 'notinvoiced';
    console.log(temp);
    scheduleData.value.push(temp);
  } else if (paymentScheduleForm.paymentType == 'burst') {
    var mediaItems = JSON.parse(paymentSchedule.contractMedia);

    var media = mediaItems.map((t) => {
      var data = {
        StartDate: t.StartDate,
        EndDate: t.EndDate,
        NoOfDays: t.NoOfDays,
        NettItemSum: t.NettItemSum,
        TotalProductionCost: t.TotalProductionCost,
        AdditionalProduction: t.AdditionalProduction,
        isBonus: t.isBonus,
      };

      if (data.isBonus) {
        // 更新bonus
        data.isBonus = t.TotalProductionCost === 0;
      }

      //同一个时间段已开发票金额
      var invoice_schedules = invoicedDetail.filter(
        (b) => b.from == t.StartDate && b.to == t.EndDate
      );
      var invoiceAmount = 0;
      if (invoice_schedules.length > 0) {
        invoiceAmount = invoice_schedules
          .map((b) => b.totalAmount)
          .reduce((a, b) => a + b);
      }

      var same_medias = mediaItems
        .filter(
          (a) =>
            a.StartDate == t.StartDate &&
            a.EndDate == t.EndDate &&
            (!t.isBonus || (t.isBonus && t.TotalProductionCost > 0))
        )
        .map((t) => {
          t.isBonus = false;
          return t;
        });

      if (same_medias.length > 0) {
        data.NettItemSum = same_medias
          .map((b) => b.NettItemSum)
          .reduce((a, b) => a + b);

        if (parseFloat(t.NettItemSum) != 0) {
          data.NettItemSum = data.NettItemSum - invoiceAmount;
        }

        data.TotalProductionCost = same_medias
          .map((b) => b.TotalProductionCost)
          .reduce((a, b) => a + b);
        if (parseFloat(t.TotalProductionCost) != 0) {
          data.TotalProductionCost = data.TotalProductionCost - invoiceAmount;
        }
        data.AdditionalProduction = same_medias
          .map((b) => b.AdditionalProduction)
          .reduce((a, b) => a + b);
      }
      return data;
    });

    // 对媒体列表去重
    media = Array.from(new Set(media.map((t) => JSON.stringify(t)))).map((t) =>
      JSON.parse(t)
    );

    console.log(media);
    media.sort(function compareFn(a, b) {
      //return b.Id - a.Id;
      return new Date(a.StartDate) - new Date(b.StartDate);
    });
    media.map((val, index) => {
      if (
        val?.isBonus ||
        (val.NettItemSum == 0 && val.TotalProductionCost == 0)
      ) {
        return;
      }
      var last_no =
        scheduleData.value.length === 0
          ? 0
          : scheduleData.value[scheduleData.value.length - 1].no;

      console.log(val, index);
      var productionAmount = 0;
      var temp = {};
      temp.no = last_no + 1;
      temp.schedule = last_no + 1;
      temp.from = val.StartDate;
      temp.to = val.EndDate;
      temp.days = val.NoOfDays;
      temp.mediaAmount = val.NettItemSum || 0;
      if (index == 0) {
        productionAmount =
          val.TotalProductionCost + paymentSchedule.AdditionalProduction;
      } else {
        productionAmount = val.TotalProductionCost;
      }
      temp.productionAmount = productionAmount || 0;
      temp.totalAmount = val.NettItemSum + productionAmount || 0;
      temp.paymentDueDate = getDueDate(
        paymentScheduleForm.paymentTerm,
        temp.from,
        temp.to,
        '',
        '',
        specialTerm
      );
      temp.invoiceDate = getDueDate(
        paymentScheduleForm.invoiceTerm,
        temp.from,
        temp.to,
        temp.paymentDueDate,
        'invoice'
      );

      temp.paymentStatus =
        dateDiffInDays(new Date(), new Date(temp.paymentDueDate)) > 30
          ? 'onschedule'
          : 'immediately';
      temp.invoiceStatus = 'notinvoiced';
      scheduleData.value.push(temp);
    });
  } else if (paymentScheduleForm.paymentType == 'installment') {
    numberOfScheduleRecord = 0;
    var firstFrom = paymentScheduleForm.campaignPeriod[0];
    var endFrom = paymentScheduleForm.campaignPeriod[1];
    var generateFrom = paymentScheduleForm.campaignPeriod[0]; // 计算开始日期
    var generateTo = paymentScheduleForm.campaignPeriod[1]; // 计算结束日期
    var totalAmount = paymentScheduleForm.mediaTotal?.moneyFormatToFloat() || 0;
    var earlyDepositAmount = 0;
    var productionAmount = 0;
    var mediaAmount = 0;
    var earlyDepositNumber = parseInt(earlyDeposit.value);
    if (invoicedDetail && invoicedDetail.length > 0) {
      // 计算分期开始的日期
      if (
        invoicedDetail
          .map((t) => t?.schedule?.toString() ?? '')
          .filter((t) => t.indexOf('Deposit') == -1).length > 0
      ) {
        var invoiced_last_date = new Date(
          invoicedDetail
            .filter((t) => t.schedule.toString().indexOf('Deposit') == -1)
            .map((t) => t.to)
            .sort((a, b) => new Date(b).getTime() - new Date(a).getTime())?.[0]
        );

        generateFrom = dateJs.ConvertDate(
          invoiced_last_date.setDate(invoiced_last_date.getDate() + 1)
        );
      }

      // 计算分期结束的日期
      if (
        invoicedDetail
          .map((t) => t?.schedule?.toString() ?? '')
          .filter((t) => t.indexOf('Deposit') >= 0).length > 0
      ) {
        earlyDepositNumber = 0;
        generateTo = dateJs.ConvertDate(
          dateJs.AddDays(
            invoicedDetail.find(
              (t) => (t?.schedule?.toString() ?? '').indexOf('Deposit') >= 0
            ).from,
            -1
          )
        );
      }
    }

    if (installmentMode.value == 'month') {
      numberOfScheduleRecord = monthDiff(
        paymentScheduleForm.campaignPeriod[0],
        paymentScheduleForm.campaignPeriod[1]
      );
      if (earlyDeposit.value != 0) {
        earlyDepositAmount =
          ((totalAmount * installmentNumberOf.value) / numberOfScheduleRecord) *
          parseInt(earlyDeposit.value);
        productionAmount =
          paymentScheduleForm.productionTotal?.moneyFormatToFloat() || 0;
        //totalAmount -= earlyDepositAmount;
        console.log(totalAmount);
        firstFrom = adjustDate(
          firstFrom,
          'addMonth',
          installmentNumberOf.value * earlyDepositNumber
        );
        // let empty = {};
        // scheduleData.value.push(empty);
      }
      //numberOfScheduleRecord = getNumberOfRecord(numberOfSchedule.value);
      //console.log(monthDiff(paymentScheduleForm.campaignPeriod[0],paymentScheduleForm.campaignPeriod[1]));
      for (let i = 0; i < numberOfScheduleRecord - earlyDepositNumber; i++) {
        let productionAmount = 0;
        let mediaAmount = 0;
        if (i == 0) {
          if (earlyDepositNumber == 0) {
            productionAmount =
              paymentScheduleForm.productionTotal?.moneyFormatToFloat() || 0;
          } else {
            productionAmount = 0;
          }
        } else {
          productionAmount = 0;
        }
        // if(i == numberOfScheduleRecord-1){

        // }
        temp = {};
        temp.no = i + 1;
        temp.schedule = i + 1;
        if (splitPref.value == 'fix') {
          if (i == 0) {
            temp.from = adjustDate(
              firstFrom,
              'addMonth',
              installmentNumberOf.value * i
            );
          } else {
            temp.from = fixDateMonth(
              fixDate.value,
              firstFrom,
              installmentNumberOf.value * i
            );
          }
          temp.to = fixDateMonth(
            fixDate.value,
            firstFrom,
            installmentNumberOf.value * (i + 1),
            'to'
          );
        } else {
          temp.from = adjustDate(
            firstFrom,
            'addMonth',
            installmentNumberOf.value * i
          );
          temp.to = adjustDate(
            firstFrom,
            'addMonthForTo',
            installmentNumberOf.value * (i + 1)
          );
        }
        if (installmentMode.value == 'month') {
          temp.days = installmentNumberOf;
        }
        mediaAmount =
          (paymentScheduleForm.mediaTotal?.moneyFormatToFloat() || 0) /
          numberOfScheduleRecord;
        temp.mediaAmount = util.getMoneyFormat(mediaAmount || 0);
        temp.productionAmount = util.getMoneyFormat(productionAmount || 0);
        temp.totalAmount = util.getMoneyFormat(
          mediaAmount + productionAmount || 0
        );
        temp.paymentDueDate = getDueDate('csdm30', temp.from, temp.to, '');
        temp.invoiceDate = getDueDate(
          'duem14',
          temp.from,
          temp.to,
          temp.paymentDueDate
        );
        temp.paymentStatus = 'immediately';
        temp.invoiceStatus = 'notinvoiced';
        scheduleData.value.push(temp);
      }
    } else if (installmentMode.value == 'day') {
      var scheduleProductionAmount =
        paymentScheduleForm.productionTotal?.moneyFormatToFloat() || 0;
      var scheduleMediaAmount =
        paymentScheduleForm.mediaTotal?.moneyFormatToFloat() || 0;

      if (installmentNumberOf.value < 28) {
        ElMessage({
          message: 'Installment Day cannot be less than 28 days.',
          type: 'warning',
        });
        return;
      }
      if (numberOfSchedule.value - earlyDeposit.value < 28) {
        ElMessage({
          message:
            'Incorrect input of Early Deposit !  The maximum day input should be ' +
            (numberOfSchedule.value - 28),
          type: 'warning',
        });
        return;
      }
      if (props.activeName == 'production') {
        totalAmount =
          paymentScheduleForm.productionTotal?.moneyFormatToFloat() || 0;
      }

      // 如果存在invoiced schedule,应除去这部分金额
      if (invoicedDetail) {
        totalAmount =
          totalAmount -
          invoicedDetail.map((t) => t.totalAmount).reduce((a, b) => a + b, 0);
        scheduleProductionAmount =
          scheduleProductionAmount -
          invoicedDetail
            .map((t) => t.productionAmount)
            .reduce((a, b) => a + b, 0);
        scheduleMediaAmount =
          scheduleMediaAmount -
          invoicedDetail.map((t) => t.mediaAmount).reduce((a, b) => a + b, 0);
      }
      var tempIn = installment.generateSchedulePerDay(
        totalAmount,
        new Date(generateFrom),
        new Date(generateTo),
        installmentNumberOf.value,
        earlyDepositNumber,
        props.activeName
      );

      // 更正拆分金额
      if (tempIn && tempIn.length > 0) {
        // 由于tempIn中计算有小数误差, 更新为两位小数
        tempIn.map((t) => {
          t.mediaAmount = parseFloat(t.mediaAmount.toFixed(2));
          t.productionAmount = parseFloat(t.productionAmount.toFixed(2));
          t.totalAmount = parseFloat(t.totalAmount.toFixed(2));
        });

        var tempIn_mediaAmount = tempIn
          .map((t) => t.mediaAmount)
          .reduce((a, b) => a + b);

        var tempIn_productionAmount = tempIn
          .map((t) => t.productionAmount)
          .reduce((a, b) => a + b);

        if (scheduleMediaAmount.toFixed(2) != tempIn_mediaAmount.toFixed(2)) {
          tempIn[tempIn.length - 1].mediaAmount = parseFloat(
            (
              tempIn[tempIn.length - 1].mediaAmount -
              (tempIn_mediaAmount - scheduleMediaAmount)
            ).toFixed(2)
          );
        }
        if (
          scheduleProductionAmount.toFixed(2) !=
          tempIn_productionAmount.toFixed(2)
        ) {
          tempIn[tempIn.length - 1].productionAmount = parseFloat(
            (
              tempIn[tempIn.length - 1].productionAmount -
              (tempIn_productionAmount - scheduleProductionAmount)
            ).toFixed(2)
          );
        }
        tempIn[tempIn.length - 1].totalAmount = parseFloat(
          (
            tempIn[tempIn.length - 1].mediaAmount +
            tempIn[tempIn.length - 1].productionAmount
          ).toFixed(2)
        );
      }

      // 合拼已经锁定的分期
      if (invoicedDetail && invoicedDetail.length > 0) {
        invoicedDetail.map((t) => {
          var temp_ele = tempIn.find((a) => a.schedule == t.schedule);
          var index = tempIn.length;
          if (temp_ele) {
            index = tempIn.indexOf(temp_ele);
          }

          var schedule = !isNaN(temp_ele?.schedule)
            ? parseInt(temp_ele.schedule)
            : 0;

          // 更新后面分期得Schedule
          if (index < tempIn.length) {
            var rowIndex = index;

            while (rowIndex < tempIn.length) {
              tempIn[rowIndex].schedule = schedule + 1;
              schedule++;
              rowIndex++;
            }
          }
        });

        tempIn = invoicedDetail.concat(tempIn);
      }

      var paymentDue = '';
      var lastMonth = 0;
      var lastYear = 0;
      // tempIn.map((val,index)=>{
      //   if(val.no == ' '){
      //     paymentDue = new Date();
      //     tempIn[index].paymentDueDate = paymentDue;
      //   }else{
      //     if(isFixDate.value){
      //       paymentDue = installment.getFixDueDate(val.from,fixDate.value,lastMonth);
      //       console.log(paymentDue,val.from,lastMonth);
      //       lastMonth = paymentDue.getMonth()+1;
      //       tempIn[index].paymentDueDate = paymentDue;
      //     }else{
      //       paymentDue = getDueDate(paymentScheduleForm.paymentTerm, val.from, val.to,'','', specialTerm);
      //       tempIn[index].paymentDueDate = paymentDue;
      //     }
      //   }
      // });
      tempIn.map((val, index) => {
        if (val.invoiceStatus == 'invoiced') {
          return;
        }

        if (val.no == ' ') {
          paymentDue = new Date();
          tempIn[index].paymentDueDate = paymentDue;
        } else {
          if (isFixDate.value) {
            paymentDue = installment.getFixDueDate(
              val.from,
              fixDate.value,
              lastMonth,
              lastYear
            );
            console.log(paymentDue, val.from, lastMonth);
            lastMonth = paymentDue.getMonth() + 1;
            lastYear = paymentDue.getFullYear();
            tempIn[index].paymentDueDate = paymentDue;
          } else {
            paymentDue = getDueDate(
              paymentScheduleForm.paymentTerm,
              val.from,
              val.to,
              '',
              '',
              specialTerm
            );
            tempIn[index].paymentDueDate = paymentDue;
          }
        }

        tempIn[index].paymentDueDate = dateJs.ConvertDate(
          tempIn[index].paymentDueDate
        );
        tempIn[index].paymentStatus =
          dateDiffInDays(new Date(), new Date(tempIn[index].paymentDueDate)) >
          30
            ? 'onschedule'
            : 'immediately';
        tempIn[index].invoiceDate = getDueDate(
          paymentScheduleForm.invoiceTerm,
          val.from,
          val.to,
          paymentDue,
          'invoice'
        );
      });
      //numberOfScheduleRecord = monthDiff(paymentScheduleForm.campaignPeriod[0],paymentScheduleForm.campaignPeriod[1]);
      // if (
      //   installmentNumberOf.value < 1 &&
      //   numberOfSchedule.value < installmentNumberOf.value + earlyDepositNumber
      // ) {
      //   ElMessage({
      //     message: 'Invalid Setting',
      //     type: 'warning',
      //   });
      //   return;
      // }

      // var endFrom6 = '';
      // temp = {};
      // productionAmount =
      //   paymentScheduleForm.productionTotal?.moneyFormatToFloat() || 0;
      // if (earlyDepositNumber > 0) {
      //   temp.from = endFrom6 = adjustDate(
      //     endFrom,
      //     'addDay',
      //     (earlyDepositNumber - 1) * -1
      //   );
      //   temp.to = endFrom;
      //   temp.no = ' ';
      //   temp.schedule = 'Early Deposit';
      //   temp.days = dateDiffInDays(temp.from, temp.to);
      //   mediaAmount = (totalAmount * temp.days) / numberOfSchedule.value;
      //   var productionAmount1 =
      //     (productionAmount * temp.days) / numberOfSchedule.value;
      //   temp.mediaAmount = mediaAmount || 0;

      //   temp.productionAmount = productionAmount1 || 0;
      //   temp.totalAmount = mediaAmount + productionAmount1 || 0;
      //   temp.paymentDueDate = getDueDate('csdm30', temp.from, temp.to, '');
      //   temp.invoiceDate = getDueDate(
      //     'duem14',
      //     temp.from,
      //     temp.to,
      //     temp.paymentDueDate
      //   );
      //   temp.paymentStatus = 'immediately';
      //   temp.invoiceStatus = 'notinvoiced';
      //   scheduleData.value.push(temp);
      // }
      // numberOfScheduleRecord = Math.ceil(
      //   (numberOfSchedule.value - earlyDepositNumber) /
      //     installmentNumberOf.value
      // );
      // for (let i = 0; i < numberOfScheduleRecord; i++) {
      //   temp = {};
      //   temp.from = adjustDate(
      //     firstFrom,
      //     'addDay',
      //     installmentNumberOf.value * i
      //   );
      //   temp.to = adjustDate(
      //     temp.from,
      //     'addDay',
      //     installmentNumberOf.value - 1
      //   );
      //   console.log(12121212, temp.to, endFrom6);
      //   if (dateDiffInDays(endFrom6, temp.to) > 0) {
      //     temp.to = adjustDate(endFrom6, 'addDay', -1);
      //   }
      //   if (dateDiffInDays(endFrom, temp.to) > 0) {
      //     temp.to = endFrom;
      //   }
      //   temp.no = i + 1;
      //   temp.schedule = i + 1;
      //   temp.days = dateDiffInDays(temp.from, temp.to);
      //   mediaAmount = (totalAmount * temp.days) / numberOfSchedule.value;
      //   temp.mediaAmount = mediaAmount || 0;
      //   productionAmount1 =
      //     (productionAmount * temp.days) / numberOfSchedule.value;
      //   temp.productionAmount = productionAmount1 || 0;
      //   temp.totalAmount = mediaAmount + productionAmount1 || 0;
      //   temp.paymentDueDate = getDueDate('csdm30', temp.from, temp.to, '');
      //   temp.invoiceDate = getDueDate(
      //     'duem14',
      //     temp.from,
      //     temp.to,
      //     temp.paymentDueDate
      //   );
      //   temp.paymentStatus = 'immediately';
      //   temp.invoiceStatus = 'notinvoiced';
      //   scheduleData.value.push(temp);
      // }
      // console.log('scheduleDatascheduleData', scheduleData.value);
      // //console.log(monthDiff(paymentScheduleForm.campaignPeriod[0],paymentScheduleForm.campaignPeriod[1]));
      // if (earlyDeposit.value != 0) {
      //   console.log(
      //     ((paymentScheduleForm.mediaTotal?.moneyFormatToFloat() || 0) *
      //       installmentNumberOf.value) /
      //       numberOfSchedule.value
      //   );
      //   earlyDepositAmount =
      //     ((totalAmount * installmentNumberOf.value) / numberOfSchedule.value) *
      //     parseInt(earlyDeposit.value);
      //   productionAmount =
      //     paymentScheduleForm.productionTotal?.moneyFormatToFloat() || 0;
      //   //totalAmount -= earlyDepositAmount;
      //   console.log(totalAmount);
      //   firstFrom = adjustDate(
      //     firstFrom,
      //     'addDay',
      //     installmentNumberOf.value * earlyDepositNumber + 1
      //   );
      //   // let empty = {};
      //   // scheduleData.value.push(empty);
      // }
      // console.log(earlyDepositNumber);
      // for (let i = 0; i < -1; i++) {
      //   temp = {};
      //   if (i == 0) {
      //     if (earlyDepositNumber == 0) {
      //       productionAmount =
      //         paymentScheduleForm.productionTotal?.moneyFormatToFloat() || 0;
      //     } else {
      //       productionAmount = 0;
      //     }
      //     temp.from = adjustDate(
      //       firstFrom,
      //       'addDay',
      //       installmentNumberOf.value * i
      //     );
      //   } else {
      //     productionAmount = 0;
      //     temp.from = adjustDate(scheduleData.value[i - 1].to, 'addDay', 1);
      //   }
      //   // if(i == numberOfScheduleRecord-1){

      //   // }
      //   temp.no = i + 1;
      //   temp.schedule = i + 1;
      //   temp.to = adjustDate(
      //     temp.from,
      //     'addDay',
      //     parseInt(installmentNumberOf.value) - 1
      //   );
      //   if (installmentMode.value == 'day') {
      //     temp.days = dateDiffInDays(temp.from, temp.to);
      //     //installmentNumberOf.value;
      //   }
      //   console.log(numberOfSchedule.value - earlyDepositNumber);
      //   mediaAmount =
      //     (totalAmount * installmentNumberOf.value) / numberOfSchedule.value;
      //   temp.mediaAmount = util.getMoneyFormat(mediaAmount || 0);
      //   temp.productionAmount = util.getMoneyFormat(productionAmount || 0);
      //   temp.totalAmount = util.getMoneyFormat(
      //     mediaAmount + productionAmount || 0
      //   );
      //   temp.paymentDueDate = getDueDate('csdm30', temp.from, temp.to, '');
      //   temp.invoiceDate = getDueDate(
      //     'duem14',
      //     temp.from,
      //     temp.to,
      //     temp.paymentDueDate
      //   );
      //   temp.paymentStatus = 'immediately';
      //   temp.invoiceStatus = 'notinvoiced';
      //   scheduleData.value.push(temp);
      // }
      scheduleData.value = tempIn;
      // if (numberOfSchedule.value % numberOfScheduleRecord != 0) {
      //   temp = {};
      //   temp.from = adjustDate(
      //     scheduleData.value[numberOfScheduleRecord - 1 - earlyDepositNumber]
      //       .to,
      //     'addDay',
      //     1
      //   );
      //   temp.no = numberOfScheduleRecord - earlyDepositNumber + 1;
      //   temp.schedule = numberOfScheduleRecord - earlyDepositNumber + 1;
      //   temp.to = util.getDateFormat(paymentScheduleForm.campaignPeriod[1]);
      //   if (installmentMode.value == 'day') {
      //     temp.days = dateDiffInDays(temp.from, temp.to);
      //     //installmentNumberOf.value;
      //   }
      //   let mediaAmount = (totalAmount * temp.days) / numberOfSchedule.value;
      //   let productionAmount = 0;
      //   temp.mediaAmount = util.getMoneyFormat(mediaAmount || 0);
      //   temp.productionAmount = util.getMoneyFormat(productionAmount || 0);
      //   temp.totalAmount = util.getMoneyFormat(
      //     mediaAmount + productionAmount || 0
      //   );
      //   temp.paymentDueDate = getDueDate('csdm30', temp.from, temp.to, '');
      //   temp.invoiceDate = getDueDate(
      //     'duem14',
      //     temp.from,
      //     temp.to,
      //     temp.paymentDueDate
      //   );
      //   temp.paymentStatus = 'immediately';
      //   temp.invoiceStatus = 'notinvoiced';
      //   scheduleData.value.push(temp);
      // }
    }
    // else if (installmentMode.value == 'day') {
    //   //numberOfScheduleRecord = monthDiff(paymentScheduleForm.campaignPeriod[0],paymentScheduleForm.campaignPeriod[1]);
    //   if (
    //     installmentNumberOf.value <1 &&
    //     numberOfSchedule.value < installmentNumberOf.value + earlyDepositNumber
    //   ) {
    //     ElMessage({
    //       message: 'Invalid Setting',
    //       type: 'warning',
    //     });
    //     return;
    //   }

    //   numberOfScheduleRecord = getNumberOfRecord(
    //     numberOfSchedule.value,
    //     1,
    //     installmentNumberOf.value
    //   );

    //   console.log(
    //     555555,
    //     numberOfSchedule.value,
    //     installmentNumberOf.value,
    //     earlyDepositNumber,
    //     numberOfScheduleRecord
    //   );
    //   //console.log(monthDiff(paymentScheduleForm.campaignPeriod[0],paymentScheduleForm.campaignPeriod[1]));
    //   if (earlyDeposit.value != 0) {
    //     console.log(
    //       ((paymentScheduleForm.mediaTotal?.moneyFormatToFloat() || 0) *
    //         installmentNumberOf.value) /
    //         numberOfSchedule.value
    //     );
    //     earlyDepositAmount =
    //       ((totalAmount * installmentNumberOf.value) / numberOfSchedule.value) *
    //       parseInt(earlyDeposit.value);
    //     productionAmount =
    //       paymentScheduleForm.productionTotal?.moneyFormatToFloat() || 0;
    //     //totalAmount -= earlyDepositAmount;
    //     console.log(totalAmount);
    //     firstFrom = adjustDate(
    //       firstFrom,
    //       'addDay',
    //       installmentNumberOf.value * earlyDepositNumber + 1
    //     );
    //     // let empty = {};
    //     // scheduleData.value.push(empty);
    //   }
    //   console.log(earlyDepositNumber);
    //   for (let i = 0; i < numberOfScheduleRecord - earlyDepositNumber; i++) {
    //     temp = {};
    //     if (i == 0) {
    //       if (earlyDepositNumber == 0) {
    //         productionAmount =
    //           paymentScheduleForm.productionTotal?.moneyFormatToFloat() || 0;
    //       } else {
    //         productionAmount = 0;
    //       }
    //       temp.from = adjustDate(
    //         firstFrom,
    //         'addDay',
    //         installmentNumberOf.value * i
    //       );
    //     } else {
    //       productionAmount = 0;
    //       temp.from = adjustDate(scheduleData.value[i - 1].to, 'addDay', 1);
    //     }
    //     // if(i == numberOfScheduleRecord-1){

    //     // }
    //     temp.no = i + 1;
    //     temp.schedule = i + 1;
    //     temp.to = adjustDate(
    //       temp.from,
    //       'addDay',
    //       parseInt(installmentNumberOf.value) - 1
    //     );
    //     if (installmentMode.value == 'day') {
    //       temp.days = dateDiffInDays(temp.from, temp.to);
    //       //installmentNumberOf.value;
    //     }
    //     console.log(numberOfSchedule.value - earlyDepositNumber);
    //     mediaAmount =
    //       (totalAmount * installmentNumberOf.value) / numberOfSchedule.value;
    //     temp.mediaAmount = util.getMoneyFormat(mediaAmount || 0);
    //     temp.productionAmount = util.getMoneyFormat(productionAmount || 0);
    //     temp.totalAmount = util.getMoneyFormat(
    //       mediaAmount + productionAmount || 0
    //     );
    //     temp.paymentDueDate = getDueDate('csdm30', temp.from, temp.to, '');
    //     temp.invoiceDate = getDueDate(
    //       'duem14',
    //       temp.from,
    //       temp.to,
    //       temp.paymentDueDate
    //     );
    //     temp.paymentStatus = 'immediately';
    //     temp.invoiceStatus = 'notinvoiced';
    //     scheduleData.value.push(temp);
    //   }
    //   if (numberOfSchedule.value % numberOfScheduleRecord != 0) {
    //     temp = {};
    //     temp.from = adjustDate(
    //       scheduleData.value[numberOfScheduleRecord - 1 - earlyDepositNumber]
    //         .to,
    //       'addDay',
    //       1
    //     );
    //     temp.no = numberOfScheduleRecord - earlyDepositNumber + 1;
    //     temp.schedule = numberOfScheduleRecord - earlyDepositNumber + 1;
    //     temp.to = util.getDateFormat(paymentScheduleForm.campaignPeriod[1]);
    //     if (installmentMode.value == 'day') {
    //       temp.days = dateDiffInDays(temp.from, temp.to);
    //       //installmentNumberOf.value;
    //     }
    //     let mediaAmount = (totalAmount * temp.days) / numberOfSchedule.value;
    //     let productionAmount = 0;
    //     temp.mediaAmount = util.getMoneyFormat(mediaAmount || 0);
    //     temp.productionAmount = util.getMoneyFormat(productionAmount || 0);
    //     temp.totalAmount = util.getMoneyFormat(
    //       mediaAmount + productionAmount || 0
    //     );
    //     temp.paymentDueDate = getDueDate('csdm30', temp.from, temp.to, '');
    //     temp.invoiceDate = getDueDate(
    //       'duem14',
    //       temp.from,
    //       temp.to,
    //       temp.paymentDueDate
    //     );
    //     temp.paymentStatus = 'immediately';
    //     temp.invoiceStatus = 'notinvoiced';
    //     scheduleData.value.push(temp);
    //   }
    // }
  }

  // 付款时间明细合计
  var totalRecord = {};
  if (scheduleData.value.length > 0) {
    totalRecord.mediaAmount = scheduleData.value
      .map((t) => t.mediaAmount)
      .reduce((a, b) => (a * 100 + b * 100) / 100);
    totalRecord.productionAmount = scheduleData.value
      .map((t) => t.productionAmount)
      .reduce((a, b) => (a * 100 + b * 100) / 100);
    totalRecord.totalAmount =
      (totalRecord.mediaAmount * 100 + totalRecord.productionAmount * 100) /
      100;
  }
  // totalRecord.mediaAmount =
  //   paymentScheduleForm.mediaTotal?.moneyFormatToFloat() || 0;
  // totalRecord.productionAmount =
  //   paymentScheduleForm.productionTotal?.moneyFormatToFloat() || 0;
  //totalRecord.totalAmount = paymentScheduleForm.grandTotal.moneyFormatToFloat();
  totalRecord.isTotal = true;
  scheduleData.value.push(totalRecord);
  if ((earlyDepositNumber || 0) != 0) {
    var earlyDepositRow = {};
    earlyDepositRow.no = '';
    earlyDepositRow.schedule = `${earlyDepositNumber}-Day Deposit`;
    earlyDepositRow.from = util.getDateFormat(
      paymentScheduleForm.campaignPeriod[0]
    );
    if (installmentMode.value == 'month') {
      earlyDepositRow.to = adjustDate(
        paymentScheduleForm.campaignPeriod[0],
        'addMonthForTo',
        earlyDepositNumber * parseInt(installmentNumberOf.value)
      );
      //earlyDepositRow.to = adjustDate(paymentScheduleForm.campaignPeriod[0],'addMonth',earlyDepositNumber*parseInt(installmentNumberOf.value));
    } else {
      earlyDepositRow.to = adjustDate(
        paymentScheduleForm.campaignPeriod[0],
        'addDay',
        earlyDepositNumber * parseInt(installmentNumberOf.value)
      );
    }

    earlyDepositRow.mediaAmount = util.getMoneyFormat(earlyDepositAmount || 0);
    productionAmount =
      paymentScheduleForm.productionTotal?.moneyFormatToFloat() || 0;
    earlyDepositRow.productionAmount = util.getMoneyFormat(
      productionAmount || 0
    );
    earlyDepositRow.totalAmount = util.getMoneyFormat(
      earlyDepositAmount + productionAmount || 0
    );
    earlyDepositRow.days =
      earlyDepositNumber * parseInt(installmentNumberOf.value);
    earlyDepositRow.paymentDueDate = getDueDate(
      'csdm30',
      earlyDepositRow.from,
      earlyDepositRow.to,
      ''
    );
    earlyDepositRow.invoiceDate = getDueDate(
      'duem14',
      earlyDepositRow.from,
      earlyDepositRow.to,
      earlyDepositRow.paymentDueDate
    );
    // scheduleData.value.unshift(earlyDepositRow);
  }
  //scheduleData.value.unshift({});
}

function disabledDate(date) {
  var start = new Date(disableCampaignDate.value[0]);
  start = start.setDate(start.getDate() - 1);
  var end = new Date(disableCampaignDate.value[1]);
  return date <= start || date >= end;
}

function disabledDate_Sub(date, sub_dates, index, fixtag) {
  const dayJs = require('dayjs');

  var start = new Date(dayJs(sub_dates?.[0]).startOf('date'));
  var end = new Date(dayJs(sub_dates?.[1]).startOf('date'));

  var filter_date;
  if (scheduleData.value.length <= index) {
    return false;
  }
  var row = scheduleData.value[index];
  if (fixtag == 'start') {
    filter_date = new Date(dayJs(row.from).startOf('date'));
  } else if (fixtag === 'end') {
    filter_date = new Date(dayJs(row.to).startOf('date'));
  } else if (fixtag === 'due') {
    filter_date = new Date(dayJs(row.paymentDueDate).startOf('date'));
    end = new Date(dayJs(row.paymentDueDate).startOf('date'));
  }

  // 验证是否小于默认disabled date
  if (filter_date) {
    if (start <= filter_date && filter_date <= end) {
      if (fixtag === 'start') {
        start = filter_date;
      }
      if (fixtag === 'end') {
        end = filter_date;
      }
    }
  }

  return (
    new Date(date).getTime() < start.getTime() ||
    new Date(date).getTime() > end.getTime()
  );
}

function monthDiff(d1, d2) {
  d1 = new Date(d1);
  d2 = new Date(d2);
  var months;
  months = (d2.getFullYear() - d1.getFullYear()) * 12;
  months -= d1.getMonth();
  months += d2.getMonth();
  return months <= 0 ? 0 : months + 1;
}

function getNumberOfRecord(totalDay, monthSplit = 1, splitDay = 28) {
  return Math.floor(totalDay / (splitDay * monthSplit));
}

function getDueDate(term, start, end, due, type, specialterm) {
  console.log(due, specialterm);
  var paymentScheduleTerm = usePaymentSchedule
    .getPaymentTerm()
    .find((t) => t.Code === term);

  if (type === 'invoice') {
    paymentScheduleTerm = usePaymentSchedule
      .getInvoiceTerm()
      .find((t) => t.Code === term);
  }

  if (specialTerms.value && type !== 'invoice') {
    console.log('is special?', specialterm, specialTerms.value);
    var SpecialTermType = specialterm?.SpecialTermType || '';
    var SpecialDays = specialterm?.Days || 1;
    switch (SpecialTermType) {
      case 'ssd':
        SpecialTermType = 'Comm Start';
        break;
      case 'sed':
        SpecialTermType = 'Comm End';
        break;
      default:
        break;
    }
    paymentScheduleTerm = {
      Setting: SpecialTermType,
      Days: parseInt(
        (specialterm?.Formula || '') == '-' ? 0 - SpecialDays : SpecialDays
      ),
    };
  }

  if (!paymentScheduleTerm) {
    return '';
  }

  var Setting = paymentScheduleTerm.Setting;
  var Days = paymentScheduleTerm.Days;
  var d;
  console.log(Setting, Days);
  if (Setting === 'Comm Start') {
    d = new Date(util.getJSDate(start));
  } else if (Setting === 'Comm End') {
    d = new Date(util.getJSDate(end));
  } else if (Setting === 'DUE') {
    d = new Date(util.getJSDate(due));
  } else {
    d = new Date();
  }

  return dateJs.ConvertDate(d.setDate(d.getDate() + Days));

  // switch (term) {
  //   case 'cod':
  //     return dateJs.ConvertDate(new Date());
  //   case 'csda21':
  //     d = new Date(util.getJSDate(start));
  //     return dateJs.ConvertDate(d.setDate(d.getDate() + 21));
  //   case 'csdm30':
  //     d = new Date(util.getJSDate(start));
  //     return dateJs.ConvertDate(d.setDate(d.getDate() - 30));
  //   case 'duem14':
  //     d = new Date(util.getJSDate(due));
  //     return dateJs.ConvertDate(d.setDate(d.getDate() - 14));
  //   case 'ced':
  //     d = new Date(util.getJSDate(end));
  //     return dateJs.ConvertDate(d);
  //   case 'ceda30':
  //     d = new Date(util.getJSDate(end));
  //     return dateJs.ConvertDate(d.setDate(d.getDate() + 30));
  // }
}

function adjustDate(date, type = 'addDay', numberOfDate = 28) {
  var d;
  d = new Date(util.getJSDate(date));
  switch (type) {
    case 'addDay':
      return util.getDateFormat2(d.setDate(d.getDate() + numberOfDate));
    case 'addDayAnd1More':
      return util.getDateFormat(d.setDate(d.getDate() + numberOfDate + 1));
    case 'minusDay':
      return util.getDateFormat(d.setDate(d.getDate() - numberOfDate));
    case 'addMonth':
      return util.getDateFormat(d.setMonth(d.getMonth() + numberOfDate));
    case 'minusMonth':
      return util.getDateFormat(d.setMonth(d.getMonth() - numberOfDate));
    case 'addMonthForTo':
      d.setMonth(d.getMonth() + numberOfDate);
      d.setDate(d.getDate() - 1);
      return util.getDateFormat(d);
  }
}

function fixDateMonth(fixDate, date, month, type = 'from') {
  var d = new Date(util.getJSDate(date));
  if (d.getDate() < fixDate) {
    d.setMonth(d.getMonth() + month - 1);
  } else {
    d.setMonth(d.getMonth() + month + 1);
  }
  if (type == 'from') {
    d.setDate(fixDate);
  } else {
    d.setDate(fixDate);
    d.setDate(d.getDate() - 1);
  }

  return util.getDateFormat(d);
}

async function newPaymentSchedule() {
  var param = {
    paymentSummary: {},
    paymentSchedule: {},
    paymentScheduleDetail: [],
    voidPaymentScheduleDetail: [],
  };

  var paymentScheduleDetail = [];
  var voidPaymentScheduleDetail = [];

  var useContract = useContractStore();
  var ContractId = useContract.Id;

  if (GenerateScheduleData.value.length > 0) {
    GenerateScheduleData.value.map((t) => (t.status = 'delete'));
  }

  var scheduleDataParam = scheduleData.value.concat(GenerateScheduleData.value);

  scheduleDataParam.map((val) => {
    var temp = {};

    if (val.schedule) {
      temp.paymentDetail_Id = val.paymentDetail_Id;
      if (!temp.paymentDetail_Id) {
        temp.paymentDetail_Id = uuidv4().toUpperCase();
      }
      temp.no = val.no;
      temp.payment_id = payment_id.value;
      temp.from = val.from;
      temp.to = val.to;
      // temp.days =
      //   dateDiffInDays(
      //     util.getDateFormat(val.from),
      //     util.getDateFormat(val.to)
      //   ) || 0;
      temp.days = val.days;
      temp.mediaAmount = val.mediaAmount;
      temp.productionAmount = val.productionAmount;
      temp.totalAmount = val.totalAmount;
      temp.paymentDue = val.paymentDueDate;
      temp.invoiceDue = val.invoiceDate;
      temp.paymentStatus = val.paymentStatus;
      temp.invoiceStatus = val.invoiceStatus;
      temp.schedule = val.schedule;
      temp.id = val?.id || 0;

      if ((val.status || '') === 'delete') {
        voidPaymentScheduleDetail.push(temp);
      } else {
        paymentScheduleDetail.push(temp);
      }
    }
  });

  // if (paymentScheduleDetail.length > 0) {
  //   paymentScheduleDetail[0].id = scheduleData.value[0].id;
  // }

  param.paymentSchedule.payment_id = payment_id.value;
  const ContractInfo = useContractInfoStore().Contract;
  param.paymentSchedule.contractDraftNo = paymentScheduleForm.contractDraftNo;
  param.paymentSchedule.id = paymentScheduleForm.id || 0;
  param.paymentSchedule.contractType = ContractInfo.contractType;
  param.paymentSchedule.contractAction = props.activeName;
  param.paymentSchedule.contractId = ContractId;
  param.paymentSchedule.campaignStart = paymentScheduleForm.campaignPeriod[0];
  param.paymentSchedule.campaignEnd = paymentScheduleForm.campaignPeriod[1];
  param.paymentSchedule.days = numberOfSchedule.value;
  param.paymentSchedule.numOfSchedule = paymentScheduleDetail.length;
  param.paymentSchedule.scheduleMedia =
    paymentScheduleForm.mediaTotal?.moneyFormatToFloat() || 0;
  param.paymentSchedule.scheduleProduction =
    paymentScheduleForm.productionTotal?.moneyFormatToFloat() || 0;
  param.paymentSchedule.totalScheduleAmount =
    (paymentScheduleForm.mediaTotal?.moneyFormatToFloat() || 0) +
    (paymentScheduleForm.productionTotal?.moneyFormatToFloat() || 0);
  param.paymentSchedule.paidAmount = 0;
  param.paymentSchedule.psType = paymentScheduleForm.paymentType;
  param.paymentSchedule.paymentTerm = paymentScheduleForm.paymentTerm;
  param.paymentSchedule.paymentTermSnap = JSON.stringify(
    paymentTerm.value
      .filter((t) => t.Code === paymentScheduleForm.paymentTerm)
      .map((t) => {
        return {
          Code: t.Code,
          Name: t.Name,
          Keyword: t.Keyword,
          Days: t.Days,
          NaturePermission: t.NaturePermission,
          Setting: t.Setting,
          Sort: t.Sort,
        };
      })
  );
  param.paymentSchedule.invoiceTerm = paymentScheduleForm.invoiceTerm;
  param.paymentSchedule.invoiceTermSnap = JSON.stringify(
    invoiceTerm.value
      .filter((t) => t.Code === paymentScheduleForm.invoiceTerm)
      .map((t) => {
        return {
          Code: t.Code,
          Name: t.Name,
          Keyword: t.Keyword,
          Days: t.Days,
          NaturePermission: t.NaturePermission,
          Setting: t.Setting,
          Sort: t.Sort,
        };
      })
  );
  param.paymentSchedule.description = paymentScheduleForm.description;
  param.paymentSchedule.currency = 'HKD';
  param.paymentSchedule.businessNature = paymentScheduleForm.businessNature;
  var tt = JSON.parse(paymentScheduleForm.keyword);
  tt.push('earlyDeposit:' + earlyDeposit.value);
  tt.push('dayPerInstallment:' + installmentNumberOf.value);
  param.paymentSchedule.keyword = JSON.stringify(tt);
  param.paymentSchedule.specialSetting = paymentScheduleForm.specialSetting;

  specialTerm.Days = SpecialPayDays.value;
  param.paymentSchedule.specialPaymentTerm = specialTerms.value
    ? JSON.stringify(specialTerm)
    : null;
  param.paymentSchedule.fixDate = JSON.stringify({
    isFixDate: isFixDate.value,
    fixDate: fixDate.value,
  });
  //}

  param.paymentSummary.id = PaymentScheduleSummary.value.id;
  param.paymentSummary.contractId = ContractId;
  param.paymentSummary.campaignStart =
    PaymentScheduleSummary.value.campaignPeriodStart;
  param.paymentSummary.campaignEnd =
    PaymentScheduleSummary.value.campaignPeriodEnd;
  param.paymentSummary.days =
    dateJs.DateDiff(
      PaymentScheduleSummary.value.campaignPeriodStart,
      PaymentScheduleSummary.value.campaignPeriodEnd
    ) + 1;
  param.paymentSummary.totalMediaAmount =
    PaymentScheduleSummary.value.totalMediaAmount;
  param.paymentSummary.totalProductionAmount =
    PaymentScheduleSummary.value.totalProductionAmount;
  param.paymentSummary.Currency = 'HKD';

  const useAuthority = useAuthorityStore();
  param.userCode = useAuthority.UserInfo.user_name;
  param.userName = useAuthority.UserInfo.name;

  param.scheduleData = scheduleData.value;
  param.paymentScheduleForm = { ...paymentScheduleForm };
  param.beforeMediaTotal = paymentScheduleForm.beforeMediaTotal;
  param.beforeProductionTotal = paymentScheduleForm.beforeProductionTotal;

  var message = '';
  const messageConfig = require('@/models/messageConfig');
  console.log(param.paymentSchedule);
  console.log(paymentScheduleDetail);
  // 验证
  if ((paymentScheduleDetail.length || 0) === 0) {
    // 在時間列表在編輯狀態時，點擊【OK】，跳出提示信息
    message = messageConfig.getMessage('paymentdetailrequire');
  } else if (
    parseFloat(param.paymentSchedule.totalScheduleAmount).toFixed(2) !==
    parseFloat(
      paymentScheduleDetail.map((t) => t.totalAmount).reduce((a, b) => a + b)
    ).toFixed(2)
  ) {
    // 檢查 Total Amount 的總和與 Total Schedule Amount 的總和，是否一致，如不是，跳出提示信息
    message = '"Total Amount" is not equal to "Total Schedule Amount"';
  } else {
    var ScheduleMediaAmount = 0;
    var ScheduleProductionAmount = 0;
    var OutstandingMedia = 0;
    var OutstandingProduction = 0;

    if (param.paymentSchedule.action !== 'production') {
      ScheduleMediaAmount = param.paymentSchedule.scheduleMedia;

      OutstandingMedia = parseFloat(
        (
          PaymentScheduleSummary.value.totalOutstandingMediaAmount +
          param.beforeMediaTotal
        ).toFixed(2)
      );
    }

    if (param.paymentSchedule.action !== 'media') {
      ScheduleProductionAmount = param.paymentSchedule.scheduleProduction;

      OutstandingProduction = parseFloat(
        (
          PaymentScheduleSummary.value.totalOutstandingProductionAmount +
          param.beforeProductionTotal
        ).toFixed(2)
      );
    }

    if (
      (param.paymentSchedule.contractAction === 'media+production' &&
        (ScheduleMediaAmount > OutstandingMedia ||
          ScheduleProductionAmount > OutstandingProduction)) ||
      (param.paymentSchedule.contractAction === 'media' &&
        ScheduleMediaAmount > OutstandingMedia) ||
      (param.paymentSchedule.contractAction === 'production' &&
        ScheduleProductionAmount > OutstandingProduction)
    ) {
      message = '"Schedule Amount" cannot greater than "Outstanding Amount"';
    }
  }

  if (!message && paymentScheduleForm.paymentType == 'installment') {
    if (installmentNumberOf.value < 28) {
      message = 'Installment Day cannot be less than 28 days.';
    }
  }

  // if (!message && paymentScheduleForm.specialSetting) {
  //   const paymentDetailRules =
  //     require('@/views/contract/rules/paymentSchedule.js').paymentScheduleDetail;

  //   for (let index = 0; index < scheduleData.value.length; index++) {
  //     const el = { ...scheduleData.value[index] };

  //     el.campaignPeriod = paymentScheduleForm.campaignPeriod;
  //     el.scheduleData = scheduleData.value.filter(
  //       (t) => !t.isTotal && t.invoiceStatus !== 'invoiced'
  //     );
  //     el.index = index;

  //     if (el.isTotal || el.invoiceStatus === 'invoiced') {
  //       continue;
  //     }

  //     const errors = await validation.validate(el, paymentDetailRules);

  //     scheduleData.value[index].validate = errors;
  //     if (!message) {
  //       message = errors?.[0]?.message;
  //     }
  //   }
  // }
  if (
    !message &&
    scheduleData.value.filter((t) => t?.validate && t.validate.length > 0)
      .length > 0
  ) {
    message = scheduleData.value.find(
      (t) => t?.validate && t.validate.length > 0
    ).validate[0].message;
  }

  if ((message || '') !== '') {
    ElMessage({
      message,
      type: 'warning',
    });
  }
  console.log('SAVE???');
  const isValid = (message || '') === '';
  if (isValid) {
    param.company_entity_id = paymentSchedule.getCompanyEntityId();

    // 重置Payment Schedule
    var paymentScheduleSave = paymentSchedule
      .getPaymentScheduleForSave()
      ?.filter((t) => t.payment_id !== payment_id.value);
    paymentSchedule.setPaymentScheduleForSave(paymentScheduleSave);

    // 重置Save Payment Detail
    var paymentScheduleDetailSave = paymentSchedule
      .getPaymentScheduleDetailForSave()
      ?.filter((t) => t.payment_id !== payment_id.value);
    console.log(paymentSchedule.getPaymentScheduleDetailForSave());
    paymentSchedule.setPaymentScheduleDetailForSave(paymentScheduleDetailSave);

    var invoiceDetails = paymentScheduleDetail.filter(
      (t) => t.invoiceStatus === 'invoiced'
    );

    var maxSchedule = parseInt(
      invoiceDetails?.[invoiceDetails?.length - 1]?.schedule ?? 0
    );
    if (!maxSchedule) {
      maxSchedule = 0;
    }

    var NewDataSort = paymentScheduleDetail
      .filter(
        (t) =>
          t.invoiceStatus !== 'invoiced' &&
          (t?.schedule?.toString() ?? '').indexOf('Deposit') < 0
      )
      .sort((a, b) => new Date(a.from).getTime() - new Date(b.from).getTime())
      .map((t, index) => {
        t.schedule = maxSchedule + index + 1;
        t.no = maxSchedule + index + 1;
        return t;
      });

    param.paymentScheduleDetail = paymentScheduleDetail
      .filter(
        (t) =>
          t.invoiceStatus !== 'invoiced' &&
          (t?.schedule?.toString() ?? '').indexOf('Deposit') >= 0
      )
      .concat(NewDataSort);

    // 重置Void Payment Detail
    var VoidPaymentScheduleDetailSave =
      paymentSchedule.getVoidPaymentScheduleDetailForSave();
    param.voidPaymentScheduleDetail = VoidPaymentScheduleDetailSave.concat(
      voidPaymentScheduleDetail
    );

    // 当前作废的付款时间明细
    param.voidPaymentScheduleDetail = param.voidPaymentScheduleDetail.concat(
      voidPaymentDetails.value
    );

    if (
      regroupNewScheduleData.value &&
      regroupData.value?.action === 'newschedule'
    ) {
      // 将挂起的原有数据更新到数据库
      paymentSchedule.setDataPrepareForSave({
        paymentSchedule: NewPaymentScheduleForSave(
          regroupNewScheduleData.value
        ),
        paymentScheduleDetail: NewScheduleData(regroupNewScheduleData.value),
      });

      // 更新到页面
      var paymentSchedulePage = paymentSchedule.getPaymentSchedule(
        regroupNewScheduleData.value.UniqueId
      );

      paymentSchedulePage.ScheduleMediaAmount =
        regroupNewScheduleData.value.ScheduleMediaAmount;
      paymentSchedulePage.ScheduleProductionAmount =
        regroupNewScheduleData.value.ScheduleProductionAmount;
      paymentSchedulePage.TotalScheduleAmount =
        regroupNewScheduleData.value.TotalScheduleAmount;
      paymentSchedulePage.NoOfSchedule =
        regroupNewScheduleData.value.NoOfSchedule;
      paymentSchedulePage.PaymentDetail =
        regroupNewScheduleData.value.PaymentDetail;

      regroupNewScheduleData.value = null;
    }

    paymentSchedule.setDataPrepareForSave(param);
  }
  if (regroupData.value?.action == 'newschedule') {
    param = Object.assign(param, {
      dialogNewType: 'new',
    });
  }
  props.saveData(param, isValid);
}

const ValidateCampaignPeriod = (data, index, type) => {
  const paymentDetailRules =
    require('@/views/contract/rules/paymentSchedule.js').paymentScheduleDetail;

  var from_source;
  var to_source;

  var scheduleDatas = [...scheduleData.value.filter((t) => !t.isTotal)];

  if (type === 'to') {
    to_source = {
      to: data.to,
      index,
      to_proposal_time:
        scheduleData.value.filter((t) => t.to == data.to).length > 1
          ? dateJs.AddDays(data.to, -1)
          : new Date(data.from).getTime(),
    };

    var nextSchedule = scheduleData.value
      .filter((t) => new Date(t.from).getTime() > new Date(data.to).getTime())
      .sort((a, b) => new Date(a.to).getTime() - new Date(b.to).getTime())?.[0];
    // 是否有上一个Schedule进行比较
    if (nextSchedule) {
      to_source.correct_time = new Date(
        dateJs.AddDays(nextSchedule.from, -1)
      ).getTime();

      if (nextSchedule.invoiceStatus !== 'invoiced') {
        from_source = {
          from: nextSchedule.from,
          index: scheduleData.value.indexOf(nextSchedule),
          correct_time: new Date(dateJs.AddDays(data.to, 1)).getTime(),
          from_proposal_time: new Date(nextSchedule.from).getTime(),
        };
      }
    } else {
      to_source.correct_time = new Date(
        paymentScheduleForm.campaignPeriod[1]
      ).getTime();
    }
  } else {
    from_source = {
      from: data.from,
      index,
      from_proposal_time:
        scheduleData.value.filter((t) => t.from == data.from).length > 1
          ? dateJs.AddDays(data.from, -1)
          : new Date(data.from).getTime(),
    };

    var lastSchedule = scheduleData.value
      .filter((t) => new Date(t.to).getTime() < new Date(data.from).getTime())
      .sort((a, b) => new Date(b.to).getTime() - new Date(a.to).getTime())?.[0];

    // 是否有上一个Schedule进行比较
    if (lastSchedule) {
      from_source.correct_time = new Date(
        dateJs.AddDays(lastSchedule.to, 1)
      ).getTime();

      to_source = {
        to: lastSchedule.to,
        correct_time: new Date(dateJs.AddDays(data.from, -1)).getTime(),
        to_proposal_time: new Date(lastSchedule.from).getTime(),
        index: scheduleData.value.indexOf(lastSchedule),
      };
    } else {
      from_source.correct_time = new Date(
        paymentScheduleForm.campaignPeriod[0]
      ).getTime();
    }
  }

  if (to_source) {
    validation
      .validate(to_source, { to: paymentDetailRules.to })
      .then((res) => {
        var row = to_source.index;
        if (!scheduleData.value[row]?.validate) {
          scheduleData.value[row].validate = [];
        }

        // 清空之前的验证
        scheduleData.value[row].validate = scheduleData.value[
          row
        ].validate.filter((t) => t.field !== 'to');

        scheduleData.value[row].validate =
          scheduleData.value[row].validate.concat(res);
      });
  }
  if (from_source) {
    validation
      .validate(from_source, { from: paymentDetailRules.from })
      .then((res) => {
        var row = from_source.index;
        if (!scheduleData.value[row]?.validate) {
          scheduleData.value[row].validate = [];
        }

        // 清空之前的验证
        scheduleData.value[row].validate = scheduleData.value[
          row
        ].validate.filter((t) => t.field !== 'from');

        scheduleData.value[row].validate =
          scheduleData.value[row].validate.concat(res);
      });
  }
};
const ValidateCampaignPeriodv2 = () => {
  const paymentDetailRules =
    require('@/views/contract/rules/paymentSchedule.js').paymentScheduleDetail;

  var rules = {
    from: paymentDetailRules.from,
    to: paymentDetailRules.to,
  };

  scheduleData.value.map(
    (t) => (t.paymentDetail_Id = t?.paymentDetail_Id ?? uuidv4())
  );
  const schedules_revise = [
    ...scheduleData.value.filter((t) => !t.isTotal),
  ].sort(
    (a, b) =>
      new Date(a.from).getTime() - new Date(b.from).getTime() ||
      new Date(a.to).getTime() - new Date(b.to).getTime() ||
      parseInt(isNaN(a.schedule) ? 99 : a.schedule) -
        parseInt(isNaN(b.schedule) ? 99 : b.schedule)
  );

  schedules_revise.map((t, index) => {
    if (t.invoiceStatus === 'invoiced') {
      return;
    }

    t.from_correct_time =
      index === 0
        ? new Date(paymentScheduleForm.campaignPeriod[0]).getTime()
        : new Date(dateJs.AddDays(schedules_revise[index - 1].to, 1)).getTime();
    t.to_correct_time =
      index === schedules_revise.length - 1
        ? new Date(paymentScheduleForm.campaignPeriod[1]).getTime()
        : new Date(
            dateJs.AddDays(schedules_revise[index + 1].from, -1)
          ).getTime();

    validation.validate(t, rules).then((res) => {
      var schedule = scheduleData.value.find(
        (b) => b.paymentDetail_Id == t.paymentDetail_Id
      );

      schedule.validate =
        schedule?.validate?.filter(
          (t) => t.field !== 'to' && t.field !== 'from'
        ) ?? [];
      schedule.validate = res.concat(schedule?.validate ?? []);
    });
  });
};

// 格式化表格
const FormatterPaymentStatus = (row, column, cellValue) => {
  const PaymentStatus = [
    {
      value: 'immediately',
      label: 'Immediately',
    },
    {
      value: 'onschedule',
      label: 'On Schedule',
    },
  ];
  return PaymentStatus.find((t) => t.value === cellValue)?.label ?? '';
};
const FormatterEarlyDepositNo = (row, column, cellValue) => {
  if (cellValue) {
    return cellValue == 0 ? ' ' : cellValue;
  }
  return '';
};
const FormatterEarlyDeposit = (row, column, cellValue) => {
  if (cellValue) {
    return cellValue == 0 ? 'Early Deposit' : cellValue;
  }
  return '';
};
const FormatterDate = (row, column, cellValue) => {
  if (cellValue) {
    return util.getDateFormat(cellValue);
  }
  return '';
};
const FormatterMoney = (row, column, cellValue) => {
  const formatJs = require('@/assets/js/formatter.js');
  if (cellValue || parseFloat(cellValue) === 0) {
    //return util.getMoneyFormat(cellValue);
    return formatJs.formatter_money(cellValue);
  }
  return '';
};
const FormatterMoneyInput = (value) => {
  return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

// Invoice
const InvoiceClick = (psid, invID, psduuid) => {
  // const psid = paymentSchedule.getPaymentSchedule(payment_id.value)?.Id || 0;
  var useContract = useContractStore();
  var Unit = useContract.Unit.alias;

  const url = `${process.env.VUE_APP_INVOICE_URL}?psid=${psid}&isEdit=true&invID=${invID}&psduuid=${psduuid}&bu=${Unit}`;
  window.open(url);
};
const getOrderClientType = () => {
  var useContract = useContractStore();
  return useContract.ContractSummary.clientType;
};
const getPaymentScheduleTermsGG = () => {
  const paymentType = paymentScheduleForm.paymentType;
  const businessNature = paymentSchedule.getBusinessNature();
  const keyword = JSON.parse(paymentScheduleForm.keyword);

  installmentNumberOf.value = 28;
  earlyDeposit.value = 0;
  isFixDate.value = false;
  fixDate.value = 1;

  paymentTerm.value = getPaymentScheduleTerms(
    paymentType,
    businessNature,
    keyword
  );

  invoiceTerm.value = getPaymentScheduleTerms(
    paymentType,
    businessNature,
    keyword,
    'invoice'
  );

  paymentScheduleForm.paymentTerm = NewPaymentTerm();
  paymentScheduleForm.invoiceTerm = NewPaymentTerm(undefined, 'invoice');

  if (paymentScheduleForm.paymentType == 'burst') {
    var contractMedias = JSON.parse(paymentSchedule.contractMedia).filter(
      (t) => !t.isBonus || (t.isBonus && t.TotalProductionCost > 0)
    );
    if (contractMedias.length > 0) {
      var start_dates = contractMedias
        .map((t) => new Date(t.StartDate))
        .sort((a, b) => a.getTime() - b.getTime());
      var end_dates = contractMedias
        .map((t) => new Date(t.EndDate))
        .sort((a, b) => b.getTime() - a.getTime());
      paymentScheduleForm.campaignPeriod = [
        dateJs.ConvertDate(start_dates[0]),
        dateJs.ConvertDate(end_dates[0]),
      ];
    }
  } else {
    var temp = paymentSchedule.getSummary();
    paymentScheduleForm.campaignPeriod = [
      dateJs.ConvertDate(temp.campaignPeriodStart),
      dateJs.ConvertDate(temp.campaignPeriodEnd),
    ];
  }
  paymentScheduleForm.days = dateDiffInDays(
    paymentScheduleForm.campaignPeriod[0],
    paymentScheduleForm.campaignPeriod[1]
  );

  GenerateScheduleData.value = GenerateScheduleData.value.concat(
    scheduleData.value.filter((t) => t.id > 0 && t.invoiceStatus !== 'invoiced')
  );
  scheduleData.value = [];
  paymentScheduleForm.specialSetting = false;

  setSpecialState();

  UpdateBulkDeleteDisable();

  UpdateSpecialSettingDisable();
};
const getPaymentScheduleTerms = (
  paymentType,
  NaturePermission,
  keyword,
  type
) => {
  const terms = [];
  const PaymentKeyword = usePaymentSchedule.getPaymentKeywords();
  const IsGovernment =
    NaturePermission === 'Government' && PaymentKeyword[0].ClientType === 'DC';
  const campaignPeriod = paymentScheduleForm.campaignPeriod[0];
  //const d = new Date(util.getJSDate(campaignPeriod));
  //d.setMonth(d.getMonth() - 1);
  //const isCod = new Date() > d;
  const isCod = isCodState(new Date(), paymentScheduleForm.campaignPeriod[0]);

  if (type !== 'invoice') {
    const PaymentTermOptions = usePaymentSchedule.getPaymentTerm();

    let targetCodes = ['csdm30', 'csdm45', 'csdm60', 'csdm75', 'csdm90'];
    if (
      PaymentKeyword[0].ClientType === 'AG' &&
      PaymentKeyword[0].AgencyType === '4A'
    ) {
      targetCodes.push('csda60');
    }

    if (paymentType === 'fullpayment') {
      if (IsGovernment) {
        targetCodes = [
          'ceda31',
          'csdm30',
          'csdm14',
          'csdm7',
          'csda7',
          'csda14',
          'csda21',
          'csda30',
          'ceda7',
          'ceda14',
        ];
      } else if (isCod) {
        targetCodes = ['cod'];
      }
    }

    const filteredOptions = PaymentTermOptions.filter((t) =>
      targetCodes.includes(t.Code)
    );

    terms.push(...filteredOptions);
  } else if (type === 'invoice') {
    const InvoiceTermOptions = usePaymentSchedule.getInvoiceTerm();
    const targetCodes =
      IsGovernment ||
      (isCod && paymentScheduleForm.paymentType === 'fullpayment')
        ? ['duem30']
        : ['duem30', 'duem60'];

    const filteredOptions = InvoiceTermOptions.filter((t) =>
      targetCodes.includes(t.Code)
    );
    terms.push(...filteredOptions);
  }

  return terms;
};
const getPaymentScheduleTerms1 = (
  paymentType,
  NaturePermission,
  keyword,
  type
) => {
  var paymentData = usePaymentSchedule.getPaymentSchedule(payment_id.value);
  var termSnap = JSON.parse(paymentData?.PaymentTermSnap || '[]');
  var terms = [];
  if (type === 'invoice') {
    termSnap = JSON.parse(paymentData?.InvoiceTermSnap || '[]');
  }

  if (termSnap.length > 0) {
    terms.push(termSnap[0]);
  }

  var PaymentTermOptions = usePaymentSchedule.getPaymentTerm();
  if (type === 'invoice') {
    PaymentTermOptions = usePaymentSchedule.getInvoiceTerm();
  }
  console.log(66666, PaymentTermOptions, terms, type);
  PaymentTermOptions = PaymentTermOptions.filter(
    (t) =>
      ((!t.PSType && t.PSType !== '') || t.PSType === paymentType) &&
      ((!t.Keyword && t.Keyword !== '') || keyword.indexOf(t.Keyword) >= 0) &&
      ((!t.NaturePermission && t.NaturePermission !== '') ||
        t.NaturePermission.indexOf(NaturePermission) >= 0)
  );

  if (terms.length > 0) {
    var termcodes = terms.map((a) => a.Code);
    PaymentTermOptions = PaymentTermOptions.filter(
      (t) => termcodes.indexOf(t.Code) < 0
    );
  }

  PaymentTermOptions.forEach((element) => {
    terms.push(element);
  });

  terms = terms.sort((a, b) => a.Sort - b.Sort);
  console.log(111111111111, PaymentTermOptions, terms, type);

  return terms;
};
const RowClassNameHandler = (item) => {
  var cell_class = [];
  if (item.row.invoiceStatus === 'invoiced') {
    cell_class.push('invoiced-row');
  }
  if ((item?.row?.schedule?.toString() ?? '').indexOf('Deposit') >= 0) {
    cell_class.push('deposit-row');
  }
  return cell_class.join(' ');
};
const SetCellClass = (item) => {
  return item.columnIndex >= 6 && item.columnIndex <= 8
    ? 'grey-background'
    : '';
};
const SetCellBackGround = (item) => {
  if (item.columnIndex >= 6 && item.columnIndex <= 8) {
    return item.row.invoiceStatus !== 'invoiced'
      ? 'grey-background'
      : 'invoiced-row';
  }
  return '';
};
const setSpecialState = () => {
  isSpecial.value =
    specialTerms.value ||
    paymentScheduleForm.specialSetting ||
    paymentScheduleForm.paymentType === 'installment';
};

const changeFixofMonth = () => {
  if (isFixDate.value) {
    paymentScheduleForm.paymentTerm = '';
    specialTerms.value = false;
    paymentScheduleForm.specialSetting = false;
    // 更新组件状态
  } else {
    paymentScheduleForm.paymentTerm = NewPaymentTerm(undefined, 'payment');
  }

  setSpecialState();
  UpdatePaymentTermDisable(isFixDate.value);
  UpdateSpecialPaymentTermDisable(isFixDate.value);
  UpdateSpecialSettingDisable();
};
// Change Special Payment Term
const changeSpecialPaymentTerm = () => {
  var isChecked = specialTerms.value;
  if (isChecked) {
    // 清空PaymentTerm
    paymentScheduleForm.paymentTerm = '';
    specialTerm.SpecialTermType = 'ssd';
    specialTerm.Formula = '+';
    specialTerm.Days = '1';

    SpecialPayDays.value = 1;
    paymentTerm.value = [];
  } else {
    var ps = paymentSchedule.getPaymentSchedule(payment_id.value);

    paymentTerm.value = getPaymentScheduleTerms(
      paymentScheduleForm.paymentType,
      paymentSchedule.getBusinessNature(),
      JSON.parse(paymentScheduleForm.keyword)
    );

    paymentScheduleForm.paymentTerm = NewPaymentTerm(ps?.PaymentTerm);

    GenerateScheduleData.value = GenerateScheduleData.value.concat(
      scheduleData.value.filter(
        (t) => t.id > 0 && t.invoiceStatus !== 'invoiced'
      )
    );

    if (
      (!paymentScheduleForm.specialSetting &&
        paymentScheduleForm.paymentType === 'installment') ||
      paymentScheduleForm.paymentType !== 'installment'
    ) {
      scheduleData.value = scheduleData.value.filter(
        (t) => t.invoiceStatus == 'invoiced'
      );
    }

    specialTerm.SpecialTermType = '';
    specialTerm.Formula = '';
    specialTerm.Days = '';

    SpecialPayDays.value = 1;
  }
};
// 更改Period
const ChangeSchedulePeriod = () => {
  var keyword = [];
  if (paymentScheduleForm.keyword) {
    keyword = JSON.parse(paymentScheduleForm.keyword);
  }

  // 更新Payment Term Snap
  var PaymentData = usePaymentSchedule.getPaymentSchedule(payment_id.value);
  if (PaymentData !== null) {
    PaymentData.PaymentTermSnap = '[]';
    PaymentData.InvoiceTermSnap = '[]';
  }

  var isCod = isCodState(new Date(), paymentScheduleForm.campaignPeriod[0]);
  // 更新Keyword
  keyword = keyword.filter((t) => t !== '' && t !== 'cod');
  keyword.push(isCod ? 'cod' : '');

  paymentScheduleForm.keyword = JSON.stringify(keyword);

  paymentScheduleForm.paymentTermSnap = '[]';

  // 更新Payment Term建议列
  paymentTerm.value = getPaymentScheduleTerms(
    paymentScheduleForm.paymentType,
    paymentSchedule.getBusinessNature(),
    JSON.parse(paymentScheduleForm.keyword)
  );
  invoiceTerm.value = getPaymentScheduleTerms(
    paymentScheduleForm.paymentType,
    paymentSchedule.getBusinessNature(),
    JSON.parse(paymentScheduleForm.keyword),
    'invoice'
  );

  // 重设Payment Term
  paymentScheduleForm.paymentTerm = NewPaymentTerm();
  paymentScheduleForm.invoiceTerm = NewPaymentTerm(undefined, 'invoice');

  // 更新启用
  bEnablePaymentTerm.value = resetTermEnable();
  bEnableInvoiceTerm.value = resetTermEnable(null, 'invoice');

  // 更新组件状态
  UpdateScheduleDisable();
};

const changePsdPeriod = (index, type) => {
  var el = scheduleData.value[index];

  if (!el.from || !el.to) {
    el.days = 0;
  } else {
    el.days = dateDiffInDays(el.from, el.to);
  }

  ValidateCampaignPeriodv2();
};
const changePaymentDue = (index) => {
  const { paymentDueDate, invoiceDate } =
    require('@/views/contract/rules/paymentSchedule.js').paymentScheduleDetail;

  const rules = { paymentDueDate, invoiceDate };

  const source = {
    paymentDueDate: scheduleData.value[index].paymentDueDate,
    invoiceDate: scheduleData.value[index].invoiceDate,
  };
  validation.validate(source, rules).then((err) => {
    scheduleData.value[index].validate =
      scheduleData.value[index]?.validate?.filter(
        (t) => t.field !== 'paymentDueDate'
      ) || [];
    scheduleData.value[index].validate =
      scheduleData.value[index].validate.concat(err);
  });
};
// Regroup DropdownList
const RegroupHandler = (command) => {
  switch (command) {
    case 'outstanding':
      RegroupWithOutStanding();
      break;
    case 'newschedule':
      RegroupWithNewSchedule();
      break;
    default:
      break;
  }
  UpdateRegroupDisable(true);
  UpdateRegenerateDisable();
};
const RegroupWithOutStanding = () => {
  //showOutstanding.value = false;
  var payment = {
    ...paymentSchedule.getPaymentSchedule(
      regroupData.value?.old_payment_id || payment_id.value
    ),
  };

  if (regroupData.value?.action === 'newschedule') {
    paymentScheduleForm.id = payment.Id;
    paymentScheduleForm.payment_id = regroupData.value.old_payment_id;
    paymentScheduleForm.psNo = payment.PSNo;
    paymentScheduleForm.description = payment.Description;
    payment_id.value = regroupData.value.old_payment_id;
  }

  if (!regroupData.value) {
    regroupData.value = {};
    regroupData.value.old_payment_id = payment_id.value;
    regroupData.value.old_mediaTotal = payment?.ScheduleMediaAmount;
    regroupData.value.old_productionTotal = payment?.ScheduleProductionAmount;
    regroupData.value.outstanding_media = OutstandingMediaAmount.value;
    regroupData.value.outstanding_production =
      OutstandingProductionAmount.value;
  }

  regroupData.value.action = 'outstanding';

  // 更新付款时间Info
  updateInfomationData();

  // 更新要移除的Detail
  GenerateScheduleData.value = GenerateScheduleData.value.concat(
    scheduleData.value.filter((t) => t.id > 0 && t.invoiceStatus !== 'invoiced')
  );

  scheduleData.value = scheduleData.value.filter(
    (t) => t.invoiceStatus === 'invoiced'
  );

  // 刷新明细
  generateSchedule();
};
const RegroupWithNewSchedule = () => {
  var invoiceScheduleData = scheduleData.value.filter(
    (t) => t.invoiceStatus == 'invoiced'
  );

  regroupNewScheduleData.value = {
    ...paymentSchedule.getPaymentSchedule(
      regroupData.value?.old_payment_id || payment_id.value
    ),
  };
  if (!regroupData.value) {
    regroupData.value = {};
    regroupData.value.old_payment_id = payment_id.value;
    regroupData.value.old_mediaTotal =
      regroupNewScheduleData.value.ScheduleMediaAmount;
    regroupData.value.old_productionTotal =
      regroupNewScheduleData.value.ScheduleProductionAmount;
    regroupData.value.outstanding_media = OutstandingMediaAmount.value;
    regroupData.value.outstanding_production =
      OutstandingProductionAmount.value;
  }
  regroupData.value.action = 'newschedule';

  regroupNewScheduleData.value.PaymentDetail =
    regroupNewScheduleData.value.PaymentDetail.filter(
      (t) => t.InvoiceStatus == 'invoiced'
    );

  var mediaTotal = 0;
  var productionTotal = 0;
  if (invoiceScheduleData.length > 0) {
    mediaTotal = invoiceScheduleData
      .map((t) => t.mediaAmount)
      .reduce((a, b) => a + b);

    productionTotal = invoiceScheduleData
      .map((t) => t.productionAmount)
      .reduce((a, b) => a + b);
  }
  // 退回的金额
  var backScheduleMediaAmount =
    regroupNewScheduleData.value.ScheduleMediaAmount - mediaTotal;
  var backScheduleProductionAmount =
    regroupNewScheduleData.value.ScheduleProductionAmount - productionTotal;

  // 更新Schedule金额
  var NewScheduleMediaAmount = parseFloat(
    (regroupData.value.outstanding_media + backScheduleMediaAmount).toFixed(2)
  );
  var NewScheduleProductionAmount = parseFloat(
    (
      regroupData.value.outstanding_production + backScheduleProductionAmount
    ).toFixed(2)
  );

  regroupNewScheduleData.value.ScheduleMediaAmount = mediaTotal;
  regroupNewScheduleData.value.ScheduleProductionAmount = productionTotal;
  regroupNewScheduleData.value.TotalScheduleAmount =
    mediaTotal + productionTotal;
  regroupNewScheduleData.value.NoOfSchedule =
    regroupNewScheduleData.value.PaymentDetail.length || 0;

  GenerateScheduleData.value = GenerateScheduleData.value.concat(
    scheduleData.value.filter((t) => t.id > 0 && t.invoiceStatus !== 'invoiced')
  );
  scheduleData.value = [];

  // 更新付款时间基本信息
  updateInfomationData();

  // 清空旧数据
  payment_id.value = uuidv4();
  paymentScheduleForm.id = '';
  paymentScheduleForm.payment_id = payment_id.value;
  paymentScheduleForm.psNo = '';
  paymentScheduleForm.description = '';
  paymentScheduleForm.mediaTotal = `$ ${FormatterMoneyInput(
    NewScheduleMediaAmount || 0
  )}`;
  paymentScheduleForm.productionTotal = `$ ${FormatterMoneyInput(
    NewScheduleProductionAmount || 0
  )}`;
  paymentScheduleForm.beforeMediaTotal = parseFloat(
    backScheduleMediaAmount.toFixed(2)
  );

  paymentScheduleForm.beforeProductionTotal = parseFloat(
    backScheduleProductionAmount.toFixed(2)
  );
  // scheduleSetting_disable
  scheduleSetting_disable.value = false;

  //更新组件状态
  UpdateRegroupDisable(true);
};

const changePsDetailMoney = async (index, type) => {
  var schedule = scheduleData.value[index];
  schedule.totalAmount =
    (parseFloat(schedule.mediaAmount) || 0) +
    (parseFloat(schedule.productionAmount) || 0);

  const paymentDetailRules =
    require('@/views/contract/rules/paymentSchedule.js').paymentScheduleDetail;

  var source = { mediaAmount: schedule.mediaAmount };
  var rules = { mediaAmount: paymentDetailRules.mediaAmount };
  if (type === 'production') {
    source = { productionAmount: schedule.productionAmount };
    rules = { productionAmount: paymentDetailRules.productionAmount };
  }

  var errors = await validation.validate(source, rules).then((res) => res);
  var row = index;
  if (errors.length > 0) {
    if (type != 'production') {
      scheduleData.value[row].mediaAmount = 0;
    } else {
      scheduleData.value[row].productionAmount = 0;
    }
  }
  watchAmount.value = true;
};

const changePsdInvoiceDate = (index) => {
  const paymentDetailRules =
    require('@/views/contract/rules/paymentSchedule.js').paymentScheduleDetail;

  validation
    .validate(scheduleData.value[index], {
      invoiceDate: paymentDetailRules.invoiceDate,
    })
    .then((res) => {
      var schedule = scheduleData.value[index];
      if (!schedule.validate) {
        schedule.validate = [];
      }

      schedule.validate = schedule.validate.filter(
        (t) => t.field !== 'invoiceDate'
      );
      if (res.length > 0) {
        schedule.validate = schedule.validate.concat(res);
      }
    });
};

const ReviseUpdate = () => {
  // 禁用按钮
  reviseUpdate_disable.value = true;

  updateInfomationData();
  generateSchedule();
};
// 更新付款时间计划信息
const updateInfomationData = () => {
  //更新付款计划设定
  if (
    new Date(disableCampaignDate.value[0]).getTime() !==
      new Date(paymentScheduleForm.campaignPeriod[0]).getTime() ||
    new Date(disableCampaignDate.value[1]).getTime() !==
      new Date(paymentScheduleForm.campaignPeriod[1]).getTime()
  ) {
    paymentScheduleForm.campaignPeriod = disableCampaignDate.value; //Schedule Period

    // 更新Days
    updateNumberOfSchedulev2();

    paymentTerm.value = getPaymentScheduleTerms(
      paymentScheduleForm.paymentType,
      paymentScheduleForm.businessNature,
      JSON.parse(paymentScheduleForm.keyword)
    );

    invoiceTerm.value = getPaymentScheduleTerms(
      paymentScheduleForm.paymentType,
      paymentScheduleForm.naturePermission,
      JSON.parse(paymentScheduleForm.keyword),
      'invoice'
    );
    // 重设Payment Term
    paymentScheduleForm.paymentTerm = NewPaymentTerm();
    paymentScheduleForm.invoiceTerm = NewPaymentTerm(undefined, 'invoice');
  }

  paymentScheduleForm.mediaTotal = `$ ${FormatterMoneyInput(
    paymentScheduleForm.mediaTotal.moneyFormatToFloat() +
      OutstandingMediaAmount.value
  )}`;
  paymentScheduleForm.productionTotal = `$ ${FormatterMoneyInput(
    paymentScheduleForm.productionTotal.moneyFormatToFloat() +
      OutstandingProductionAmount.value
  )}`;
  paymentScheduleForm.grandTotal = `$ ${FormatterMoneyInput(
    paymentScheduleForm.mediaTotal.moneyFormatToFloat() +
      paymentScheduleForm.productionTotal.moneyFormatToFloat()
  )}`;
};

const FixNumber = (value) => {
  if (isNaN(value)) {
    return 0;
  }

  return Math.round(value, 0);
};
const FixNumberv2 = (value) => {
  if (isNaN(value) || !value) {
    return 1;
  }

  return Math.round(value, 0);
};
const addSchedule = () => {
  if (scheduleData.value.length == 0) {
    UpdateTotalRecord();
  }

  scheduleData.value.splice(scheduleData.value.length - 1, 0, {
    id: 0,
    no:
      scheduleData.value.filter(
        (t) =>
          !t.isTotal && (t?.schedule?.toString() ?? '').indexOf('Deposit') < 0
      ).length + 1,
    schedule:
      scheduleData.value.filter(
        (t) =>
          !t.isTotal && (t?.schedule?.toString() ?? '').indexOf('Deposit') < 0
      ).length + 1,
    paymentDetail_Id: uuidv4(),
    mediaAmount: 0,
    productionAmount: 0,
    totalAmount: 0,
    from: null,
    to: null,
    days: 0,
    paymentDueDate: null,
    invoiceDate: null,
    paymentStatus: 'onschedule',
    invoiceStatus: 'notinvoiced',
  });

  const rules =
    require('@/views/contract/rules/paymentSchedule.js').paymentScheduleDetail;
  validation
    .validate(scheduleData.value[scheduleData.value.length - 2], rules)
    .then((err) => {
      scheduleData.value[scheduleData.value.length - 2].validate = err;
    });
};

watch(
  () => paymentScheduleForm.campaignPeriod,
  (value, oldValue) => {
    if (value) {
      if (value[0] && value[1]) {
        updateNumberOfSchedule(dateDiffInDays(value[0], value[1]));
      }
      //console.log(dateDiffInDays(value[0],value[1]), oldValue)
    }
  },
  { immediate: true }
);
watch(
  () => props.payment_id,
  (value) => {
    payment_id.value = value;
  },
  { immediate: true }
);
watch(
  () => props.status,
  (value, oldValue) => {
    if (value) {
      init();
    }
  },
  { immediate: true }
);
watch(
  () => props.save,
  (value, oldValue) => {
    if (value) {
      newPaymentSchedule();
    }
  },
  { immediate: true }
);
watch(
  () => paymentScheduleForm.mediaTotal,
  (value, oldValue) => {
    paymentScheduleForm.grandTotal = `$ ${
      (value?.moneyFormatToFloat() || 0) +
      (paymentScheduleForm.productionTotal?.moneyFormatToFloat() || 0)
    }`;

    if (props.activeName !== 'production') {
      var old = oldValue;
      old = old?.moneyFormatToFloat() || 0;
      if (!oldValue) {
        old = value?.moneyFormatToFloat() || 0;
      }

      OutstandingMediaAmount.value =
        OutstandingMediaAmount.value + old - (value?.moneyFormatToFloat() || 0);
    }

    // 更新组件状态
    UpdateScheduleDisable();
  },
  { immediate: true }
);
watch(
  () => paymentScheduleForm.productionTotal,
  (value, oldValue) => {
    paymentScheduleForm.grandTotal = `$ ${
      (paymentScheduleForm.mediaTotal?.moneyFormatToFloat() || 0) +
      (value?.moneyFormatToFloat() || 0)
    }`;

    if (props.activeName !== 'media') {
      var old = oldValue;
      old = old?.moneyFormatToFloat() || 0;
      if (!oldValue) {
        old = value?.moneyFormatToFloat() || 0;
      }

      OutstandingProductionAmount.value =
        OutstandingProductionAmount.value +
        old -
        (value?.moneyFormatToFloat() || 0);
    }

    // 更新组件状态
    UpdateScheduleDisable();
  },
  { immediate: true }
);
watch(
  () => specialTerms.value,
  (value, oldValue) => {
    if (oldValue !== undefined) {
      if (value) {
        paymentScheduleForm.specialSetting = false;
      }

      changeSpecialPaymentTerm();
    }
    // 更新Payment Term组件状态
    UpdatePaymentTermDisable(value);
    UpdateFixDateDisable();
    setSpecialState();
  },
  { immediate: true }
);
watch(
  () => paymentScheduleForm.specialSetting,
  (value, oldValue) => {
    isAddSchedule.value = value;

    if (oldValue !== undefined) {
      if (value) {
        specialTerms.value = false;

        paymentTerm.value = getPaymentScheduleTerms(
          paymentScheduleForm.paymentType,
          paymentScheduleForm.businessNature,
          JSON.parse(paymentScheduleForm.keyword)
        );

        isFixDate.value = false;
        fixDate.value = 1;

        changeFixofMonth();
      } else {
        GenerateScheduleData.value = GenerateScheduleData.value.concat(
          scheduleData.value.filter(
            (t) => t.id > 0 && t.invoiceStatus !== 'invoiced'
          )
        );
        scheduleData.value = scheduleData.value.filter(
          (t) => t.invoiceStatus === 'invoiced'
        );

        if (!paymentScheduleForm.paymentTerm) {
          paymentScheduleForm.paymentTerm = NewPaymentTerm(
            undefined,
            'payment'
          );
        }
      }
    }
    setSpecialState();
    UpdateFixDateDisable();
  },
  { immediate: true }
);
watch(
  () => isFixDate,
  (value, oldValue) => {
    console.log(value);
  },
  { immediate: true }
);

// watch(
//   () => OutstandingProductionAmount.value || OutstandingMediaAmount.value,
//   (value, oldValue) => {
//     showOutstanding.value =
//       paymentScheduleForm.id > 0 &&
//       bHasRevise.value &&
//       OutstandingProductionAmount.value + OutstandingMediaAmount.value !== 0;
//   },
//   { immediate: true }
// );
watch(
  () => paymentScheduleForm.description,
  (value, oldValue) => {
    console.log(value);
  },
  { immediate: true }
);
watch(
  () => installmentMode.value,
  (value, oldValue) => {
    console.log(value);
    if (value == 'month') {
      installmentTitle.value = 'Installment (per Months)';
      installmentNumberOf.value = 1;
    } else {
      installmentTitle.value = 'Installment (per Days)';
      splitPref.value = 'ssd';
      if (shouldUpdate) {
        installmentNumberOf.value = 28;
        earlyDeposit.value = 0;
      } else {
        shouldUpdate = true;
      }
    }
  },
  { immediate: true }
);
watch(
  () => SpecialPayDays.value,
  (value, oldValue) => {
    specialTerm.Days = value;
  },
  { immediate: true }
);
watch(
  () => fixDate.value,
  (value, oldValue) => {
    if (value) {
      if (value > 31) {
        fixDate.value = '31';
      } else {
        if (value < 1) {
          fixDate.value = '1';
        } else {
          fixDate.value = value;
        }
      }
    }
  },
  { immediate: true }
);
watch(
  () => watchAmount.value,
  (val) => {
    if (val) {
      var mediaAmounts = scheduleData.value
        .filter((t) => !t.isTotal)
        .map((t) => parseFloat(t.mediaAmount));
      var productionAmounts = scheduleData.value
        .filter((t) => !t.isTotal)
        .map((t) => parseFloat(t.productionAmount));

      const totalRecord = scheduleData.value.find((t) => t.isTotal);
      if (totalRecord) {
        totalRecord.mediaAmount =
          mediaAmounts.length === 0
            ? 0
            : mediaAmounts.reduce((a, b) => (a || 0) + (b || 0));
        //paymentScheduleForm.mediaTotal?.moneyFormatToFloat() || 0;
        totalRecord.productionAmount =
          productionAmounts.length === 0
            ? 0
            : productionAmounts.reduce((a, b) => (a || 0) + (b || 0));
        //paymentScheduleForm.productionTotal?.moneyFormatToFloat() || 0;
        totalRecord.totalAmount =
          (totalRecord.mediaAmount || 0) + (totalRecord.productionAmount || 0);
      }
    }
    watchAmount.value = false;
  },
  { immediate: true }
);
watch(
  () => paymentTerm_disable.value,
  (value) => {
    if (!value && paymentTerm.value.length === 0) {
      paymentTerm.value = getPaymentScheduleTerms(
        paymentScheduleForm.paymentType,
        paymentScheduleForm.businessNature,
        JSON.parse(paymentScheduleForm.keyword)
      );

      paymentScheduleForm.paymentTerm = NewPaymentTerm(undefined, 'payment');
    }
  }
);
</script>
<style scoped>
.special-terms-days .el-input__wrapper .el-input__inner {
  padding: 0px !important;
}

.form-check-sign {
  top: -9px;
  left: -6px;
}

.rotate {
  height: 20px;
  cursor: pointer;
  transform: rotate(90deg);
}

.rotate {
  height: 20px;
  cursor: pointer;
  transform: rotate(90deg);
  margin-top: 10px;
}
</style>
<style>
.payment-money-input .el-input__wrapper {
  box-shadow: 0 0 0 1px #1d253b inset !important;
}

.payment-money-input .el-input__wrapper .el-input__inner:disabled {
  background-color: transparent;
}

.invoiced-row {
  background-color: #ecb4b8 !important;
}
.deposit-row .cell {
  font-weight: 700;
}

.text-right {
  text-align: right;
}

.special-payment-term .form-check-label {
  padding-left: 18px !important;
}

.range-picker-red {
  color: #ec250d !important;
}

.regroup-outstanding {
  color: #b60005;
  margin-bottom: 10px;
}

.payment-dropdown.is-disabled {
  background-color: #1a202c;
  opacity: 0.3;
}

.payment-dropdown.is-disabled span {
  color: #fff;
  cursor: no-drop;
}
.icon-button.add {
  background-color: #409eff;
  color: #fff;
}
.icon-button {
  border-radius: 50%;
  width: 20px;
  height: 20px;
}
.add-schedule .text {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
</style>
<style>
.el-input-number.black {
  width: auto !important;
}
.el-input-number.black .el-input-number__decrease,
.el-input-number.black.is-disabled .el-input-number__decrease:hover,
.el-input-number.black .el-input-number__increase,
.el-input-number.black.is-disabled .el-input-number__increase:hover {
  height: 50% !important;
  border-radius: 0px !important;
  background: var(--el-fill-color-light) !important;
  box-shadow: none !important;
  color: var(--el-text-color-regular) !important;
  margin-bottom: 1px;
  margin-top: 1px;
}
#SpecialPayDaysId {
  height: 80%;
}
.cell .form-group {
  margin-bottom: auto;
}
.cell .form-group .el-input__inner {
  height: 36px;
}
</style>
